!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("prop-types"), require("react"));else if ("function" == typeof define && define.amd) define(["prop-types", "React"], t);else {
    var r = "object" == typeof exports ? t(require("prop-types"), require("react")) : t(e.PropTypes, e.React);
    for (var n in r) ("object" == typeof exports ? exports : e)[n] = r[n];
  }
}(window, function (e, t) {
  return function (e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var s = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(s.exports, s, s.exports, r), s.l = !0, s.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "/dist/", r(r.s = 8);
  }([function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, r, n, s, o, i, a) {
      if (!e) {
        var c;
        if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var l = [r, n, s, o, i, a],
            p = 0;
          (c = new Error(t.replace(/%s/g, function () {
            return l[p++];
          }))).name = "Invariant Violation";
        }
        throw c.framesToPop = 1, c;
      }
    };
  }, function (e, t, r) {
    "use strict";

    (function (e, n) {
      var s,
        o = r(6);
      s = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e ? e : n;
      var i = Object(o.a)(s);
      t.a = i;
    }).call(this, r(4), r(14)(e));
  }, function (e, t) {
    var r;
    r = function () {
      return this;
    }();
    try {
      r = r || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == typeof window && (r = window);
    }
    e.exports = r;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return function (t) {
        var r = t.dispatch,
          n = t.getState;
        return function (t) {
          return function (s) {
            return "function" == typeof s ? s(r, n, e) : t(s);
          };
        };
      };
    }
    t.__esModule = !0;
    var s = n();
    s.withExtraArgument = n, t.default = s;
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      var t,
        r = e.Symbol;
      return "function" == typeof r ? r.observable ? t = r.observable : (t = r("observable"), r.observable = t) : t = "@@observable", t;
    }
    r.d(t, "a", function () {
      return n;
    });
  }, function (e, t, r) {
    e.exports = function () {
      "use strict";

      var e = {
          childContextTypes: !0,
          contextTypes: !0,
          defaultProps: !0,
          displayName: !0,
          getDefaultProps: !0,
          getDerivedStateFromProps: !0,
          mixins: !0,
          propTypes: !0,
          type: !0
        },
        t = {
          name: !0,
          length: !0,
          prototype: !0,
          caller: !0,
          callee: !0,
          arguments: !0,
          arity: !0
        },
        r = Object.defineProperty,
        n = Object.getOwnPropertyNames,
        s = Object.getOwnPropertySymbols,
        o = Object.getOwnPropertyDescriptor,
        i = Object.getPrototypeOf,
        a = i && i(Object);
      return function c(l, p, u) {
        if ("string" != typeof p) {
          if (a) {
            var d = i(p);
            d && d !== a && c(l, d, u);
          }
          var f = n(p);
          s && (f = f.concat(s(p)));
          for (var h = 0; h < f.length; ++h) {
            var _ = f[h];
            if (!(e[_] || t[_] || u && u[_])) {
              var g = o(p, _);
              try {
                r(l, _, g);
              } catch (e) {}
            }
          }
          return l;
        }
        return l;
      };
    }();
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var n = r(1),
      s = r.n(n),
      o = r(0),
      i = r.n(o),
      a = i.a.shape({
        trySubscribe: i.a.func.isRequired,
        tryUnsubscribe: i.a.func.isRequired,
        notifyNestedSubs: i.a.func.isRequired,
        isSubscribed: i.a.func.isRequired
      }),
      c = i.a.shape({
        subscribe: i.a.func.isRequired,
        dispatch: i.a.func.isRequired,
        getState: i.a.func.isRequired
      }),
      l = function () {
        var e,
          t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "store",
          r = arguments[1] || t + "Subscription",
          s = function (e) {
            function s(r, n) {
              !function (e, t) {
                if (!(e instanceof s)) throw new TypeError("Cannot call a class as a function");
              }(this);
              var o = function (e, t) {
                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t;
              }(this, e.call(this, r, n));
              return o[t] = r.store, o;
            }
            return function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }(s, e), s.prototype.getChildContext = function () {
              var e;
              return (e = {})[t] = this[t], e[r] = null, e;
            }, s.prototype.render = function () {
              return n.Children.only(this.props.children);
            }, s;
          }(n.Component);
        return s.propTypes = {
          store: c.isRequired,
          children: i.a.element.isRequired
        }, s.childContextTypes = ((e = {})[t] = c.isRequired, e[r] = a, e), s;
      }(),
      p = r(7),
      u = r.n(p),
      d = r(2),
      f = r.n(d),
      h = null,
      _ = {
        notify: function notify() {}
      },
      g = function () {
        function e(t, r, n) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.store = t, this.parentSub = r, this.onStateChange = n, this.unsubscribe = null, this.listeners = _;
        }
        return e.prototype.addNestedSub = function (e) {
          return this.trySubscribe(), this.listeners.subscribe(e);
        }, e.prototype.notifyNestedSubs = function () {
          this.listeners.notify();
        }, e.prototype.isSubscribed = function () {
          return Boolean(this.unsubscribe);
        }, e.prototype.trySubscribe = function () {
          var e, t;
          this.unsubscribe || (this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange), this.listeners = (e = [], t = [], {
            clear: function clear() {
              t = h, e = h;
            },
            notify: function notify() {
              for (var r = e = t, n = 0; n < r.length; n++) r[n]();
            },
            get: function get() {
              return t;
            },
            subscribe: function subscribe(r) {
              var n = !0;
              return t === e && (t = e.slice()), t.push(r), function () {
                n && e !== h && (n = !1, t === e && (t = e.slice()), t.splice(t.indexOf(r), 1));
              };
            }
          }));
        }, e.prototype.tryUnsubscribe = function () {
          this.unsubscribe && (this.unsubscribe(), this.unsubscribe = null, this.listeners.clear(), this.listeners = _);
        }, e;
      }(),
      b = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      },
      m = 0,
      x = {};
    function y() {}
    function O(e) {
      var t,
        r,
        s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        o = s.getDisplayName,
        i = void 0 === o ? function (e) {
          return "ConnectAdvanced(" + e + ")";
        } : o,
        l = s.methodName,
        p = void 0 === l ? "connectAdvanced" : l,
        d = s.renderCountProp,
        h = void 0 === d ? void 0 : d,
        _ = s.shouldHandleStateChanges,
        O = void 0 === _ || _,
        E = s.storeKey,
        v = void 0 === E ? "store" : E,
        T = s.withRef,
        S = void 0 !== T && T,
        R = function (e, t) {
          var r = {};
          for (var n in e) t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
          return r;
        }(s, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]),
        A = v + "Subscription",
        j = m++,
        C = ((t = {})[v] = c, t[A] = a, t),
        w = ((r = {})[A] = a, r);
      return function (t) {
        f()("function" == typeof t, "You must pass a component to the function returned by " + p + ". Instead received " + JSON.stringify(t));
        var r = t.displayName || t.name || "Component",
          s = i(r),
          o = b({}, R, {
            getDisplayName: i,
            methodName: p,
            renderCountProp: h,
            shouldHandleStateChanges: O,
            storeKey: v,
            withRef: S,
            displayName: s,
            wrappedComponentName: r,
            WrappedComponent: t
          }),
          a = function (r) {
            function i(e, t) {
              !function (e, t) {
                if (!(e instanceof i)) throw new TypeError("Cannot call a class as a function");
              }(this);
              var n = function (e, t) {
                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t;
              }(this, r.call(this, e, t));
              return n.version = j, n.state = {}, n.renderCount = 0, n.store = e[v] || t[v], n.propsMode = Boolean(e[v]), n.setWrappedInstance = n.setWrappedInstance.bind(n), f()(n.store, 'Could not find "' + v + '" in either the context or props of "' + s + '". Either wrap the root component in a <Provider>, or explicitly pass "' + v + '" as a prop to "' + s + '".'), n.initSelector(), n.initSubscription(), n;
            }
            return function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }(i, r), i.prototype.getChildContext = function () {
              var e,
                t = this.propsMode ? null : this.subscription;
              return (e = {})[A] = t || this.context[A], e;
            }, i.prototype.componentDidMount = function () {
              O && (this.subscription.trySubscribe(), this.selector.run(this.props), this.selector.shouldComponentUpdate && this.forceUpdate());
            }, i.prototype.componentWillReceiveProps = function (e) {
              this.selector.run(e);
            }, i.prototype.shouldComponentUpdate = function () {
              return this.selector.shouldComponentUpdate;
            }, i.prototype.componentWillUnmount = function () {
              this.subscription && this.subscription.tryUnsubscribe(), this.subscription = null, this.notifyNestedSubs = y, this.store = null, this.selector.run = y, this.selector.shouldComponentUpdate = !1;
            }, i.prototype.getWrappedInstance = function () {
              return f()(S, "To access the wrapped instance, you need to specify { withRef: true } in the options argument of the " + p + "() call."), this.wrappedInstance;
            }, i.prototype.setWrappedInstance = function (e) {
              this.wrappedInstance = e;
            }, i.prototype.initSelector = function () {
              var t = e(this.store.dispatch, o);
              this.selector = function (e, t) {
                var r = {
                  run: function run(n) {
                    try {
                      var s = e(t.getState(), n);
                      (s !== r.props || r.error) && (r.shouldComponentUpdate = !0, r.props = s, r.error = null);
                    } catch (e) {
                      r.shouldComponentUpdate = !0, r.error = e;
                    }
                  }
                };
                return r;
              }(t, this.store), this.selector.run(this.props);
            }, i.prototype.initSubscription = function () {
              if (O) {
                var e = (this.propsMode ? this.props : this.context)[A];
                this.subscription = new g(this.store, e, this.onStateChange.bind(this)), this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
              }
            }, i.prototype.onStateChange = function () {
              this.selector.run(this.props), this.selector.shouldComponentUpdate ? (this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate, this.setState(x)) : this.notifyNestedSubs();
            }, i.prototype.notifyNestedSubsOnComponentDidUpdate = function () {
              this.componentDidUpdate = void 0, this.notifyNestedSubs();
            }, i.prototype.isSubscribed = function () {
              return Boolean(this.subscription) && this.subscription.isSubscribed();
            }, i.prototype.addExtraProps = function (e) {
              if (!(S || h || this.propsMode && this.subscription)) return e;
              var t = b({}, e);
              return S && (t.ref = this.setWrappedInstance), h && (t[h] = this.renderCount++), this.propsMode && this.subscription && (t[A] = this.subscription), t;
            }, i.prototype.render = function () {
              var e = this.selector;
              if (e.shouldComponentUpdate = !1, e.error) throw e.error;
              return Object(n.createElement)(t, this.addExtraProps(e.props));
            }, i;
          }(n.Component);
        return a.WrappedComponent = t, a.displayName = s, a.childContextTypes = w, a.contextTypes = C, a.propTypes = C, u()(a, t);
      };
    }
    var E = Object.prototype.hasOwnProperty;
    function v(e, t) {
      return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
    }
    function T(e, t) {
      if (v(e, t)) return !0;
      if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
      var r = Object.keys(e),
        n = Object.keys(t);
      if (r.length !== n.length) return !1;
      for (var s = 0; s < r.length; s++) if (!E.call(t, r[s]) || !v(e[r[s]], t[r[s]])) return !1;
      return !0;
    }
    var S = r(3),
      R = {
        INIT: "@@redux/INIT" + Math.random().toString(36).substring(7).split("").join("."),
        REPLACE: "@@redux/REPLACE" + Math.random().toString(36).substring(7).split("").join(".")
      },
      A = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
      j = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      };
    function C(e, t, r) {
      var n;
      if ("function" == typeof t && void 0 === r && (r = t, t = void 0), void 0 !== r) {
        if ("function" != typeof r) throw new Error("Expected the enhancer to be a function.");
        return r(C)(e, t);
      }
      if ("function" != typeof e) throw new Error("Expected the reducer to be a function.");
      var s = e,
        o = t,
        i = [],
        a = i,
        c = !1;
      function l() {
        a === i && (a = i.slice());
      }
      function p() {
        if (c) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
        return o;
      }
      function u(e) {
        if ("function" != typeof e) throw new Error("Expected the listener to be a function.");
        if (c) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
        var t = !0;
        return l(), a.push(e), function () {
          if (t) {
            if (c) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
            t = !1, l();
            var r = a.indexOf(e);
            a.splice(r, 1);
          }
        };
      }
      function d(e) {
        if (!function (e) {
          if ("object" !== (void 0 === e ? "undefined" : A(e)) || null === e) return !1;
          for (var t = e; null !== Object.getPrototypeOf(t);) t = Object.getPrototypeOf(t);
          return Object.getPrototypeOf(e) === t;
        }(e)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
        if (void 0 === e.type) throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
        if (c) throw new Error("Reducers may not dispatch actions.");
        try {
          c = !0, o = s(o, e);
        } finally {
          c = !1;
        }
        for (var t = i = a, r = 0; r < t.length; r++) (0, t[r])();
        return e;
      }
      return d({
        type: R.INIT
      }), (n = {
        dispatch: d,
        subscribe: u,
        getState: p,
        replaceReducer: function replaceReducer(e) {
          if ("function" != typeof e) throw new Error("Expected the nextReducer to be a function.");
          s = e, d({
            type: R.REPLACE
          });
        }
      })[S.a] = function () {
        var e,
          t = u;
        return (e = {
          subscribe: function subscribe(e) {
            if ("object" !== (void 0 === e ? "undefined" : A(e)) || null === e) throw new TypeError("Expected the observer to be an object.");
            function r() {
              e.next && e.next(p());
            }
            return r(), {
              unsubscribe: t(r)
            };
          }
        })[S.a] = function () {
          return this;
        }, e;
      }, n;
    }
    function w(e, t) {
      return function () {
        return t(e.apply(this, arguments));
      };
    }
    var D = r(15),
      L = "object" == typeof self && self && self.Object === Object && self,
      k = (D.a || L || Function("return this")()).Symbol,
      I = Object.prototype;
    I.hasOwnProperty, I.toString, k && k.toStringTag, Object.prototype.toString, k && k.toStringTag, Object.getPrototypeOf, Object;
    var P = Function.prototype,
      H = Object.prototype,
      N = P.toString;
    function q(e) {
      return function (t, r) {
        var n = e(t, r);
        function s() {
          return n;
        }
        return s.dependsOnOwnProps = !1, s;
      };
    }
    function U(e) {
      return null !== e.dependsOnOwnProps && void 0 !== e.dependsOnOwnProps ? Boolean(e.dependsOnOwnProps) : 1 !== e.length;
    }
    function M(e, t) {
      return function (t, r) {
        r.displayName;
        var n = function n(e, t) {
          return n.dependsOnOwnProps ? n.mapToProps(e, t) : n.mapToProps(e);
        };
        return n.dependsOnOwnProps = !0, n.mapToProps = function (t, r) {
          n.mapToProps = e, n.dependsOnOwnProps = U(e);
          var s = n(t, r);
          return "function" == typeof s && (n.mapToProps = s, n.dependsOnOwnProps = U(s), s = n(t, r)), s;
        }, n;
      };
    }
    H.hasOwnProperty, N.call(Object);
    var F = [function (e) {
        return "function" == typeof e ? M(e) : void 0;
      }, function (e) {
        return e ? void 0 : q(function (e) {
          return {
            dispatch: e
          };
        });
      }, function (e) {
        return e && "object" == typeof e ? q(function (t) {
          return function (e, t) {
            if ("function" == typeof e) return w(e, t);
            if ("object" !== (void 0 === e ? "undefined" : A(e)) || null === e) throw new Error("bindActionCreators expected an object or a function, instead received " + (null === e ? "null" : void 0 === e ? "undefined" : A(e)) + '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
            for (var r = Object.keys(e), n = {}, s = 0; s < r.length; s++) {
              var o = r[s],
                i = e[o];
              "function" == typeof i && (n[o] = w(i, t));
            }
            return n;
          }(e, t);
        }) : void 0;
      }],
      B = [function (e) {
        return "function" == typeof e ? M(e) : void 0;
      }, function (e) {
        return e ? void 0 : q(function () {
          return {};
        });
      }],
      z = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      };
    function K(e, t, r) {
      return z({}, r, e, t);
    }
    var G = [function (e) {
      return "function" == typeof e ? function (e) {
        return function (t, r) {
          r.displayName;
          var n = r.pure,
            s = r.areMergedPropsEqual,
            o = !1,
            i = void 0;
          return function (t, r, a) {
            var c = e(t, r, a);
            return o ? n && s(c, i) || (i = c) : (o = !0, i = c), i;
          };
        };
      }(e) : void 0;
    }, function (e) {
      return e ? void 0 : function () {
        return K;
      };
    }];
    function W(e, t) {
      var r = t.initMapStateToProps,
        n = t.initMapDispatchToProps,
        s = t.initMergeProps,
        o = function (e, t) {
          var r = {};
          for (var n in e) t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
          return r;
        }(t, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]),
        i = r(e, o),
        a = n(e, o),
        c = s(e, o);
      return (o.pure ? function (e, t, r, n, s) {
        var o = s.areStatesEqual,
          i = s.areOwnPropsEqual,
          a = s.areStatePropsEqual,
          c = !1,
          l = void 0,
          p = void 0,
          u = void 0,
          d = void 0,
          f = void 0;
        function h(s, c) {
          var h,
            _,
            g = !i(c, p),
            b = !o(s, l);
          return l = s, p = c, g && b ? (u = e(l, p), t.dependsOnOwnProps && (d = t(n, p)), f = r(u, d, p)) : g ? (e.dependsOnOwnProps && (u = e(l, p)), t.dependsOnOwnProps && (d = t(n, p)), f = r(u, d, p)) : b ? (h = e(l, p), _ = !a(h, u), u = h, _ && (f = r(u, d, p)), f) : f;
        }
        return function (s, o) {
          return c ? h(s, o) : (u = e(l = s, p = o), d = t(n, p), f = r(u, d, p), c = !0, f);
        };
      } : function (e, t, r, n) {
        return function (s, o) {
          return r(e(s, o), t(n, o), o);
        };
      })(i, a, c, e, o);
    }
    var Y = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    };
    function V(e, t, r) {
      for (var n = t.length - 1; n >= 0; n--) {
        var s = t[n](e);
        if (s) return s;
      }
      return function (t, n) {
        throw new Error("Invalid value of type " + typeof e + " for " + r + " argument when connecting component " + n.wrappedComponentName + ".");
      };
    }
    function J(e, t) {
      return e === t;
    }
    var Q = function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = e.connectHOC,
          r = void 0 === t ? O : t,
          n = e.mapStateToPropsFactories,
          s = void 0 === n ? B : n,
          o = e.mapDispatchToPropsFactories,
          i = void 0 === o ? F : o,
          a = e.mergePropsFactories,
          c = void 0 === a ? G : a,
          l = e.selectorFactory,
          p = void 0 === l ? W : l;
        return function (e, t, n) {
          var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
            a = o.pure,
            l = void 0 === a || a,
            u = o.areStatesEqual,
            d = void 0 === u ? J : u,
            f = o.areOwnPropsEqual,
            h = void 0 === f ? T : f,
            _ = o.areStatePropsEqual,
            g = void 0 === _ ? T : _,
            b = o.areMergedPropsEqual,
            m = void 0 === b ? T : b,
            x = function (e, t) {
              var r = {};
              for (var n in e) t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
              return r;
            }(o, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]),
            y = V(e, s, "mapStateToProps"),
            O = V(t, i, "mapDispatchToProps"),
            E = V(n, c, "mergeProps");
          return r(p, Y({
            methodName: "connect",
            getDisplayName: function getDisplayName(e) {
              return "Connect(" + e + ")";
            },
            shouldHandleStateChanges: Boolean(e),
            initMapStateToProps: y,
            initMapDispatchToProps: O,
            initMergeProps: E,
            pure: l,
            areStatesEqual: d,
            areOwnPropsEqual: h,
            areStatePropsEqual: g,
            areMergedPropsEqual: m
          }, x));
        };
      }(),
      Z = function Z(e, t) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return function (e, t) {
          var r = [],
            n = !0,
            s = !1,
            o = void 0;
          try {
            for (var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
          } catch (e) {
            s = !0, o = e;
          } finally {
            try {
              !n && a.return && a.return();
            } finally {
              if (s) throw o;
            }
          }
          return r;
        }(e, t);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
      X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
      $ = function $(e) {
        return e instanceof Array;
      },
      ee = function ee(e) {
        return "string" == typeof e;
      },
      te = function te(e) {
        return null !== e && "object" === (void 0 === e ? "undefined" : X(e)) && !Array.isArray(e);
      },
      re = function re(e) {
        return !isNaN(parseFloat(e)) && isFinite(e);
      },
      ne = function ne(e) {
        return e.constructor === String ? "" === e : e.constructor !== Object || Array.isArray(e) ? e.constructor === Array && 0 === e.length : 0 === Object.keys(e).length;
      },
      se = function se(e, t, r, n) {
        var s = ["disabled", "multiple", "placeHolderInside", "arrow", "customScrollbar", "searchable", "commaSeperated", "singleLine", "checkBoxes", "materialize", "tags"],
          o = "",
          i = !0,
          a = !1,
          c = void 0;
        try {
          for (var l, p = Object.entries(e)[Symbol.iterator](); !(i = (l = p.next()).done); i = !0) {
            var u = l.value,
              d = Z(u, 2),
              f = d[0];
            !0 === d[1] && s.includes(f) && (o += "rs-base-" + f.toLowerCase() + " ");
          }
        } catch (e) {
          a = !0, c = e;
        } finally {
          try {
            !i && p.return && p.return();
          } finally {
            if (a) throw c;
          }
        }
        return t && (o += "rs-base-open "), 0 === r.length && (o += "rs-base-empty "), n.enabled && (o += "rs-base-tags "), "" !== e.className && (o += e.className), "" !== (o = o.trim()) ? " " + o : "";
      },
      oe = function oe(e, t) {
        var r = {
            selected: [],
            selectedIndex: []
          },
          n = !0,
          s = !1,
          o = void 0;
        try {
          for (var i, a = t.entries()[Symbol.iterator](); !(n = (i = a.next()).done); n = !0) {
            var c = i.value,
              l = Z(c, 2),
              p = l[0],
              u = l[1];
            $(e) ? e.includes(u.key) && (r.selected.push(u.key), r.selectedIndex.push(p)) : e === u.key && (r.selected.push(u.key), r.selectedIndex.push(p));
          }
        } catch (e) {
          s = !0, o = e;
        } finally {
          try {
            !n && a.return && a.return();
          } finally {
            if (s) throw o;
          }
        }
        return r;
      },
      ie = function ie(e, t) {
        if (!t) return !1;
        var r = t.offsetTop,
          n = e.scrollTop,
          s = e.clientHeight,
          o = t.clientHeight;
        return (r - n <= 0 || r - n >= s) && r - s + o;
      },
      ae = function ae(e, t, r) {
        var n = void 0;
        return function () {
          var s = this,
            o = arguments,
            i = r && !n;
          clearTimeout(n), n = setTimeout(function () {
            n = null, r || e.apply(s, o);
          }, t), i && e.apply(s, o);
        };
      };
    function ce(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function le(e) {
      if (Array.isArray(e)) {
        for (var t = 0, r = Array(e.length); t < e.length; t++) r[t] = e[t];
        return r;
      }
      return Array.from(e);
    }
    "undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register($, "isArray", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(ee, "isString", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(te, "isObject", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(re, "isNumeric", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(ne, "isEmpty", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(se, "buildClassName", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(function (e, t) {
      return t.filter(function (t) {
        return t.key === e;
      })[0];
    }, "getFocusedItemByKey", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      return 0 === e.length ? "" : !1 === t ? e[0] : "";
    }, "getSelectValue", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(function (e, t) {
      var r = !0,
        n = !1,
        s = void 0;
      try {
        for (var o, i = t.entries()[Symbol.iterator](); !(r = (o = i.next()).done); r = !0) {
          var a = o.value,
            c = Z(a, 2),
            l = c[0];
          if (e === c[1].key) return l;
        }
      } catch (e) {
        n = !0, s = e;
      } finally {
        try {
          !r && i.return && i.return();
        } finally {
          if (n) throw s;
        }
      }
      return !1;
    }, "getSelectedIndex", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(oe, "normalizeSelected", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(ie, "isInViewport", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(function (e, t) {
      return -1 !== t.findIndex(function (t) {
        return t.key === e;
      });
    }, "itemInOptions", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"), __REACT_HOT_LOADER__.register(ae, "debounce", "D:/xampp/htdocs/react-selectrix/src/helpers/index.js"));
    var pe = function pe(e) {
        return function (t, r) {
          var n = r(),
            s = {
              key: "tag-" + e,
              label: e
            };
          t({
            type: "CREATE_TAG",
            tag: s,
            options: [].concat(le(n.options), [s]),
            resultSet: [].concat(le(n.search.resultSet), [s])
          }), n = r();
          var o = [].concat(le(n.settings.searchable ? n.search.resultSet : n.options));
          (n.settings.commaSeperated || n.settings.checkBoxes) && (o = o.filter(function (e) {
            return !n.selected.includes(e.key);
          })), t(Ee(o.length - 1)), t({
            type: "CLEAR_SEARCH"
          });
        };
      },
      ue = function ue(e) {
        return function (t, r) {
          t({
            type: "REMOVE_ITEM",
            index: e
          });
          var n = r();
          n.isOpen || t(Te()), n.onChange([].concat(le(n.selectedIndex)).map(function (e) {
            var t;
            return n.customKeys ? Object.assign({}, (ce(t = {}, n.customKeys.key, n.options[e].key), ce(t, n.customKeys.label, n.options[e].label), t)) : n.options[e];
          }));
        };
      },
      de = function de(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return function (r, n) {
          var s = n(),
            o = {},
            i = [].concat(le(e.options));
          t && s.tags.tagSet.length > 0 && (i = [].concat(le(e.options), le(s.tags.tagSet)));
          var a = {
            active: !1,
            url: "",
            debounce: 200,
            fetchOnSearch: !1,
            q: "",
            fetching: !1,
            needsUpdate: !0,
            nestedKey: !1,
            searchPrompt: !0,
            minLength: 1,
            headers: {}
          };
          if (e.customKeys) {
            var c = ["key", "label"];
            Object.keys(e.customKeys).forEach(function (t) {
              c.includes(t) && (o[t] = e.customKeys[t]);
            });
          }
          (o = !ne(o) && Object.assign({
            key: "key",
            label: "label"
          }, o)) && (i = i.map(function (e) {
            return e.hasOwnProperty(o.key) && e.hasOwnProperty(o.label) ? {
              key: e[o.key],
              label: e[o.label]
            } : null;
          }).filter(function (e) {
            return e;
          }));
          var l = e.defaultValue ? oe(e.defaultValue, [].concat(le(i))) : {
              selected: s.selected,
              selectedIndex: s.selectedIndex
            },
            p = l.selected,
            u = l.selectedIndex;
          e.ajax && e.ajax.hasOwnProperty("url") && "" !== e.ajax.url && (i = p = u = [], a.active = !0, a.url = e.ajax.url, e.ajax.hasOwnProperty("debounce") && re(e.ajax.debounce) && (a.debounce = e.ajax.debounce), e.ajax.fetchOnSearch && !ne(e.ajax.q) && ee(e.ajax.q) && (a.fetchOnSearch = !0, a.q = e.ajax.q), e.ajax.hasOwnProperty("nestedKey") && ee(e.ajax.nestedKey) && (a.nestedKey = e.ajax.nestedKey), e.ajax.hasOwnProperty("searchPrompt") && (a.searchPrompt = a.fetchOnSearch && !1 === e.ajax.searchPrompt), e.ajax.hasOwnProperty("minLength") && re(e.ajax.minLength) && a.fetchOnSearch && (a.minLength = e.ajax.minLength), e.ajax.hasOwnProperty("headers") && te(e.ajax.headers) && (a.headers = e.ajax.headers)), r({
            type: t ? "UPDATE_INSTANCE" : "SETUP_INSTANCE",
            props: e,
            selected: p,
            selectedIndex: u,
            options: i,
            customKeys: o,
            ajax: a
          });
        };
      },
      fe = function fe(e) {
        return {
          type: "SET_QUERY_STRING",
          queryString: e
        };
      },
      he = function he(e) {
        return function (t, r) {
          r().isOpen || t(Te()), t({
            type: "SET_TAG",
            tag: e
          }), t(ge());
        };
      },
      _e = function _e(e) {
        return function (t, r) {
          if ("" !== e) {
            var n = r();
            if (n.isOpen || t(Te()), n.ajax.active && n.ajax.fetchOnSearch && e.length >= n.ajax.minLength) return t({
              type: "CLEAR_OPTIONS"
            }), t(be()).then(t(Se())).catch(function (e) {
              return console.error(e);
            });
            t({
              type: "SEARCH_OPTIONS",
              queryString: e
            });
          } else t({
            type: "CLEAR_SEARCH"
          });
          var s = r();
          return s.tags.active ? t(ge()) : s.settings.multiple ? t(we(0)) : void (s.search.active ? t(we(0)) : t({
            type: "CHECK_FOR_SCROLL"
          }));
        };
      },
      ge = function ge() {
        return {
          type: "FOCUS_TAG"
        };
      },
      be = function be() {
        return function (e, t) {
          return new Promise(function (r, n) {
            var s = t();
            if (s.isOpen) {
              e({
                type: "FETCHING_OPTIONS"
              });
              var o = s.ajax.url;
              s.ajax.fetchOnSearch && (o += s.ajax.q.replace("{q}", s.search.queryString)), fetch(o, {
                headers: s.ajax.headers
              }).then(function (e) {
                if (!e.ok) throw "Your ajax url " + s.ajax.url + " failed with a status " + e.status;
                var t = e.headers.get("content-type");
                if (t && t.includes("application/json")) return e.json();
                throw "Your ajax url " + s.ajax.url + " response was not a json";
              }).then(function (t) {
                if (s.ajax.nestedKey) {
                  if (!t.hasOwnProperty(s.ajax.nestedKey)) throw "Invalid nested key on " + s.ajax.url + " response";
                  t = t[s.ajax.nestedKey];
                }
                if (!$(t)) throw "Invalid data type on " + s.ajax.url + " response. Expected array.";
                e(me(t)), r(t);
              }).catch(function (e) {
                n(e);
              });
            }
          });
        };
      },
      me = function me(e) {
        return function (t, r) {
          var n = r();
          if (n.isOpen) {
            var s = n.customKeys && n.customKeys.hasOwnProperty("key") ? n.customKeys.key : "key",
              o = n.customKeys && n.customKeys.hasOwnProperty("label") ? n.customKeys.label : "label";
            t({
              type: "SETUP_AJAX_OPTIONS",
              options: e.map(function (e) {
                if (!e.hasOwnProperty(s) || !e.hasOwnProperty(o)) return null;
                var t = {
                  key: e[s],
                  label: e[o]
                };
                return e.hasOwnProperty("disabled") && e.disabled && (t.disabled = !0), t;
              }).filter(function (e) {
                return e;
              })
            });
          }
        };
      },
      xe = function xe() {
        return function (e, t) {
          t().isOpen ? e(Re()) : e(Te());
        };
      },
      ye = function ye() {
        return function (e, t) {
          var r = t(),
            n = r.selected,
            s = r.selectedIndex,
            o = r.ajax,
            i = r.options;
          if (r.settings.multiple) {
            if (o.fetchOnSearch) return r.onChange(n);
            r.onChange([].concat(le(s)).map(function (e) {
              return i[e];
            }));
          } else r.onChange(i[s[0]]);
        };
      },
      Oe = function Oe() {
        return function (e, t) {
          e({
            type: "SELECT_ALL"
          });
          var r = t();
          e(ye()), r.settings.stayOpen || e(Re());
        };
      },
      Ee = function Ee(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        return function (r, n) {
          if (-1 === e) return r(ve());
          var s = n(),
            o = s.search.active ? s.search.resultSet : s.options,
            i = s.ajax.fetchOnSearch ? s.selected.map(function (e) {
              return e.key;
            }) : s.selected;
          !s.settings.multiple || s.settings.commaSeperated || s.settings.checkBoxes || (o = [].concat(le(o)).filter(function (e) {
            return !i.includes(e.key);
          }));
          var a = s.search.active || s.settings.multiple && !s.settings.commaSeperated && !s.settings.checkBoxes ? s.options.findIndex(function (t) {
            return t.key === o[e].key;
          }) : e;
          if ((s.settings.commaSeperated || s.settings.checkBoxes) && s.selectedIndex.includes(a)) return r(ue(a));
          o[e] && (r({
            type: "SELECT_ITEM",
            item: o[e],
            index: s.search.active || s.settings.multiple && i.length ? a : e,
            isKeyboard: t
          }), s.settings.stayOpen || r(Re())), !(s = n()).isOpen || !s.settings.multiple || s.settings.checkBoxes || s.settings.commaSeperated || s.settings.isDropDown || (t ? e === o.length - 1 ? r(we(e - 1)) : r(we(e)) : e === o.length - 1 && r(we(e - 1))), r(ye());
        };
      },
      ve = function ve() {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        return function (t, r) {
          var n = r();
          t({
            type: "CLEAR_SELECT",
            stayOpen: e
          }), n.onChange(""), n.settings.stayOpen || t(Re());
        };
      },
      Te = function Te() {
        return function (e, t) {
          e({
            type: "OPEN_SELECT"
          });
          var r = t();
          r.onOpen(), r.ajax.active && !r.ajax.fetchOnSearch && r.ajax.needsUpdate ? e(be()).then(function () {
            return e(Se());
          }).catch(function (e) {
            return console.error(e);
          }) : e(Se());
        };
      },
      Se = function Se() {
        return function (e, t) {
          var r = t();
          if (r.settings.isDropDown) return e(we(0));
          if (r.isOpen && (0 === r.selected.length || r.settings.multiple || r.settings.checkBoxes) && null === r.focusedItem) if (r.settings.checkBoxes && !r.settings.multiple) e(we(r.selectedIndex[0]));else if (r.settings.multiple && r.settings.commaSeperated && r.selected.length > 0) {
            var n = r.settings.lifo ? r.selectedIndex[0] : r.selectedIndex[r.selectedIndex.length - 1];
            e(we(n));
          } else e(je("down"));
        };
      },
      Re = function Re() {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        return function (t, r) {
          t({
            type: "CLOSE_SELECT",
            blur: e
          }), r().onClose();
        };
      },
      Ae = function Ae(e) {
        return function (t, r) {
          var n = r(),
            s = e.key;
          switch (s) {
            case "Tab":
              n.isOpen ? t(Re(!0)) : n.focused && t({
                type: "BLUR_SELECT"
              });
              break;
            case "Enter":
              if (e.preventDefault(), n.isOpen) {
                if (null !== n.focusedItem) t(Ee(n.focusedItemIndex, !0));else {
                  if (n.tags.active) return t(pe(n.search.queryString));
                  t(Re());
                }
              } else t(Te());
              break;
            case "Esc":
            case "Escape":
              t(Re());
              break;
            case "Up":
            case "Left":
            case "ArrowUp":
            case "ArrowLeft":
              if (n.search.active && n.search.queryString.length > 0 && ["Left", "ArrowLeft"].includes(s)) return;
              e.preventDefault(), t(je("up"));
              break;
            case "Down":
            case "Right":
            case "ArrowDown":
            case "ArrowRight":
              if (n.search.active && n.search.queryString.length > 0 && ["Right", "ArrowRight"].includes(s)) return;
              e.preventDefault(), t(je("down"));
          }
        };
      },
      je = function je(e) {
        return function (t, r) {
          var n = r(),
            s = !n.settings.multiple && n.settings.placeHolderInside,
            o = n.search.active ? n.search.resultSet : n.options;
          !n.settings.multiple || n.settings.commaSeperated || n.settings.checkBoxes || (o = [].concat(le(o)).filter(function (e) {
            return !n.selected.includes(e.key);
          }));
          var i,
            a = !1;
          null !== n.focusedItem ? a = n.focusedItemIndex : n.selected.length > 0 && !n.settings.multiple && !n.settings.isDropDown && (n.search.active ? -1 === (a = o.findIndex(function (e) {
            return e.key === n.options[n.selectedIndex].key;
          })) && (a = !1) : a = n.selectedIndex[0]), !1 !== (i = !1 !== a ? "up" === e ? n.tags.active && 0 === a ? "tag" : a > 0 || s ? a - 1 : 0 : a + 1 < o.length ? a + 1 : o.length - 1 : n.tags.active && "up" === e ? "tag" : "up" === e ? o.length - 1 : s ? -1 : 0) && (!1 === n.isOpen && t(Te()), t("tag" === i ? ge() : we(i, !1)));
        };
      },
      Ce = function Ce(e, t) {
        return function (r) {
          var n = ie(e, t),
            s = 0;
          n && (s = n, e.scrollTop = n), r({
            type: "SCROLL_SELECT",
            active: !1 !== n,
            scroll: s
          });
        };
      },
      we = function we(e, t) {
        return function (r, n) {
          var s = n(),
            o = s.search.active ? s.search.resultSet : s.options,
            i = s.ajax.fetchOnSearch ? s.selected.map(function (e) {
              return e.key;
            }) : s.selected;
          !s.settings.multiple || s.settings.commaSeperated || s.settings.checkBoxes || (o = [].concat(le(o)).filter(function (e) {
            return !i.includes(e.key);
          })), (o[e] || -1 === e && s.settings.placeHolderInside) && r({
            type: "FOCUS_ITEM",
            item: -1 !== e ? o[e] : {
              key: "default"
            },
            index: e,
            mouseEvent: t
          });
        };
      },
      De = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register("SETUP_INSTANCE", "SETUP_INSTANCE", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("UPDATE_INSTANCE", "UPDATE_INSTANCE", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("CLOSE_SELECT", "CLOSE_SELECT", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("OPEN_SELECT", "OPEN_SELECT", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("SELECT_ITEM", "SELECT_ITEM", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("SELECT_MULTI_ITEM", "SELECT_MULTI_ITEM", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("FOCUS_ITEM", "FOCUS_ITEM", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("CLEAR_SELECT", "CLEAR_SELECT", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("FOCUS_SELECT", "FOCUS_SELECT", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("BLUR_SELECT", "BLUR_SELECT", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("SCROLL_SELECT", "SCROLL_SELECT", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("SEARCH_OPTIONS", "SEARCH_OPTIONS", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("UNLOCK_MOUSE_FOCUS", "UNLOCK_MOUSE_FOCUS", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("REMOVE_ITEM", "REMOVE_ITEM", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("CLEAR_SEARCH", "CLEAR_SEARCH", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("CHECK_FOR_SCROLL", "CHECK_FOR_SCROLL", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("SELECT_ALL", "SELECT_ALL", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("FETCHING_OPTIONS", "FETCHING_OPTIONS", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("SETUP_AJAX_OPTIONS", "SETUP_AJAX_OPTIONS", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("CLEAR_OPTIONS", "CLEAR_OPTIONS", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("SET_QUERY_STRING", "SET_QUERY_STRING", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("CREATE_TAG", "CREATE_TAG", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("FOCUS_TAG", "FOCUS_TAG", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register("SET_TAG", "SET_TAG", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(pe, "createTag", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(ue, "removeItem", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(function () {
        return {
          type: "CHECK_FOR_SCROLL"
        };
      }, "checkForScroll", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(de, "setupInstance", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(function () {
        return {
          type: "CLEAR_OPTIONS"
        };
      }, "clearOptions", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(fe, "setQueryString", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(he, "setTag", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(_e, "searchOptions", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(ge, "focusTag", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(be, "fetchOptions", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(me, "setupAjaxOptions", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(xe, "toggleSelect", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(ye, "returnValue", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(Oe, "selectAll", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(Ee, "selectItem", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(ve, "clearSelect", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(Te, "openSelect", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(Se, "findFocusedItem", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(Re, "closeSelect", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(function () {
        return function (e, t) {
          t().focused || e({
            type: "FOCUS_SELECT"
          });
        };
      }, "focusSelect", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(function () {
        return {
          type: "BLUR_SELECT"
        };
      }, "blurSelect", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(Ae, "handleKeyDown", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(je, "moveFocus", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(Ce, "maybeScroll", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(we, "focusItem", "D:/xampp/htdocs/react-selectrix/src/actions/index.js"), __REACT_HOT_LOADER__.register(function () {
        return {
          type: "UNLOCK_MOUSE_FOCUS"
        };
      }, "unlockMouseFocus", "D:/xampp/htdocs/react-selectrix/src/actions/index.js")), r(13), function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }()),
      Le = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);
          var r = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return r.onSearch = ae(function (e) {
            r.props.searchOptions(e);
          }, r.props.ajax.debounce), r.state = {
            size: e.settings.multiple ? "1" : "20"
          }, r.calculateSize = r.calculateSize.bind(r), r.onSearch = r.onSearch.bind(r), r;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, s.a.Component), De(t, [{
          key: "calculateSize",
          value: function value(e) {
            if (e.settings.multiple) {
              var t = 1;
              "" === e.queryString ? 0 === e.selected.length && e.settings.placeholder && (t = e.settings.placeholder.length) : t = e.queryString.length, this.setState({
                size: 0 === t ? "1" : t.toString()
              });
            }
          }
        }, {
          key: "componentWillMount",
          value: function value() {
            this.calculateSize(this.props);
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            (e.settings.multiple && (this.props.queryString !== e.queryString || this.props.selected.length !== e.selected.length) || this.props.settings.placeholder.length !== e.settings.placeholder.length) && this.calculateSize(e), e.focused && this.input.focus();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = "rs-searchable",
              r = this.props.settings.multiple,
              n = this.props,
              o = n.focused,
              i = n.queryString,
              a = "";
            return r ? 0 === this.props.selected.length && (a = this.props.settings.placeholder) : (t += " rs-toggle", a = this.props.selected && !this.props.settings.isDropDown ? this.props.selected.label : this.props.settings.placeholder), o && (t += " rs-focused"), i && (t += " rs-active"), s.a.createElement("input", {
              ref: function ref(t) {
                return e.input = t;
              },
              onFocus: this.props.focusSelect,
              type: "text",
              id: "searchable",
              className: t,
              placeholder: a,
              value: this.props.queryString,
              onChange: function onChange(t) {
                var r = t.target.value;
                if (e.props.ajax.fetchOnSearch) return e.props.setQueryString(r), e.onSearch(r);
                e.props.settings.searchable ? e.props.searchOptions(r) : e.props.setTag(r);
              },
              size: this.state.size
            });
          }
        }]), t;
      }(),
      ke = Le,
      Ie = ke;
    Le.propTypes = {
      queryString: i.a.string,
      searchOptions: i.a.func.isRequired,
      focusSelect: i.a.func.isRequired,
      blurSelect: i.a.func.isRequired,
      selected: i.a.oneOfType([i.a.object, i.a.array]),
      settings: i.a.object.isRequired,
      isOpen: i.a.bool.isRequired,
      focused: i.a.bool.isRequired,
      ajax: i.a.object.isRequired,
      setQueryString: i.a.func.isRequired,
      setTag: i.a.func.isRequired,
      tags: i.a.object.isRequired
    }, "undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(Le, "Searchable", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Header/partials/Searchable/Searchable.js"), __REACT_HOT_LOADER__.register(ke, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Header/partials/Searchable/Searchable.js"));
    var Pe = function Pe(e) {
        return {
          settings: e.settings,
          selected: e.settings.multiple ? e.selected : e.selected.length > 0 ? e.options[e.selectedIndex] : null,
          isOpen: e.isOpen,
          queryString: e.search.queryString,
          focused: e.focused,
          ajax: e.ajax,
          tags: e.tags
        };
      },
      He = function He(e) {
        return {
          searchOptions: function searchOptions(t) {
            e(_e(t));
          },
          focusSelect: function focusSelect() {
            e(function (e, t) {
              t().focused || e({
                type: "FOCUS_SELECT"
              });
            });
          },
          setTag: function setTag(t) {
            e(he(t));
          },
          blurSelect: function blurSelect() {
            e({
              type: "BLUR_SELECT"
            });
          },
          setQueryString: function setQueryString(t) {
            e(fe(t));
          }
        };
      },
      Ne = Q(Pe, He)(Ie),
      qe = Ne,
      Ue = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(Pe, "mapStateToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Header/partials/Searchable/index.js"), __REACT_HOT_LOADER__.register(He, "mapDispatchToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Header/partials/Searchable/index.js"), __REACT_HOT_LOADER__.register(Ne, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Header/partials/Searchable/index.js")), function (e) {
        var t = e.settings,
          r = e.isOpen,
          n = e.selected,
          o = e.focused,
          i = e.onRenderSelection,
          a = e.tags,
          c = t.searchable || a.enabled ? s.a.createElement(qe, null) : s.a.createElement("div", {
            tabIndex: "0",
            className: "rs-toggle" + (o ? " rs-focused" : "")
          }, null === n || t.isDropDown ? t.placeholder : n.label);
        if (!t.searchable && !1 !== i) {
          var l = i(n, t);
          l && (c = l);
        }
        return s.a.createElement("div", {
          className: "rs-header",
          onClick: e.toggleSelect
        }, !t.placeHolderInside && !t.isDropDown && null !== n && s.a.createElement("span", {
          className: "rs-reset-wrapper vertical-align"
        }, s.a.createElement("span", {
          className: "rs-reset",
          onClick: function onClick(t) {
            return e.clearSelect(t);
          }
        }, "×")), t.arrow && s.a.createElement("span", {
          className: "rs-arrow-wrapper vertical-align"
        }, s.a.createElement("span", {
          className: "rs-arrow-indicator " + (r ? "up" : "down")
        })), c);
      });
    Ue.propTypes = {
      settings: i.a.object.isRequired,
      isOpen: i.a.bool.isRequired,
      selected: i.a.object,
      toggleSelect: i.a.func.isRequired,
      clearSelect: i.a.func.isRequired,
      focused: i.a.bool.isRequired,
      onRenderSelection: i.a.oneOfType([i.a.func, i.a.bool]),
      tags: i.a.object.isRequired
    };
    var Me = Ue,
      Fe = Me,
      Be = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(Ue, "Header", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Header/Header.js"), __REACT_HOT_LOADER__.register(Me, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Header/Header.js")), function (e) {
        return {
          settings: e.settings,
          selected: e.selected.length > 0 ? e.options[e.selectedIndex] : null,
          isOpen: e.isOpen,
          focused: e.focused,
          onRenderSelection: e.onRenderSelection,
          tags: e.tags
        };
      }),
      ze = function ze(e) {
        return {
          toggleSelect: function toggleSelect() {
            e(xe());
          },
          clearSelect: function clearSelect() {
            var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            t && (t.stopPropagation(), t.nativeEvent.stopImmediatePropagation()), e(ve());
          }
        };
      },
      Ke = Q(Be, ze)(Fe),
      Ge = Ke,
      We = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(Be, "mapStateToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Header/index.js"), __REACT_HOT_LOADER__.register(ze, "mapDispatchToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Header/index.js"), __REACT_HOT_LOADER__.register(Ke, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Header/index.js")), function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }()),
      Ye = function (e) {
        function t(e) {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, s.a.Component), We(t, [{
          key: "getJSX",
          value: function value() {
            var e = this,
              t = this.props,
              r = t.selected,
              n = t.settings,
              o = t.selectedIndex,
              i = t.options,
              a = t.ajax,
              c = t.onRenderSelection,
              l = t.tags,
              p = [],
              u = [];
            return 0 === r.length ? p.push(n.searchable || l.enabled ? "" : n.placeholder) : (u = a.active && a.fetchOnSearch ? r : o, n.commaSeperated ? p.push(s.a.createElement("span", {
              key: "commaSeperated",
              className: "rs-commaseperated-wrapper"
            }, o.map(function (e) {
              return i[e].label;
            }).join(", "))) : u.map(function (t) {
              var r = a.active && a.fetchOnSearch ? t.key : t,
                o = a.active && a.fetchOnSearch ? t.label : i[t].label,
                l = function l(t) {
                  t.stopPropagation(), e.props.removeItem(r);
                };
              if (!1 !== c) {
                var u = c(i[t], n, l);
                u && p.push(u);
              } else p.push(s.a.createElement("div", {
                key: "selection-" + r,
                className: "rs-selection"
              }, s.a.createElement("span", {
                className: "rs-remove vertical-align",
                onClick: l
              }, s.a.createElement("span", null, "×")), o));
            })), (n.searchable || l.enabled) && p.push(s.a.createElement(qe, {
              key: "searchable"
            })), p;
          }
        }, {
          key: "render",
          value: function value() {
            var e = this.props,
              t = e.settings,
              r = e.isOpen,
              n = e.selected,
              o = "rs-toggle";
            return e.focused && (o += " rs-focused"), s.a.createElement("div", {
              className: "rs-header",
              onClick: function onClick(n) {
                t.searchable ? r ? n.preventDefault() : e.openSelect() : e.toggleSelect();
              }
            }, n.length > 0 && s.a.createElement("span", {
              className: "rs-reset-wrapper vertical-align"
            }, s.a.createElement("span", {
              className: "rs-reset",
              onClick: function onClick(t) {
                return e.clearSelect(t);
              }
            }, "×")), t.arrow && s.a.createElement("span", {
              className: "rs-arrow-wrapper vertical-align"
            }, s.a.createElement("span", {
              className: "rs-arrow-indicator " + (r ? "up" : "down")
            })), s.a.createElement("div", {
              tabIndex: "0",
              className: o
            }, this.getJSX()));
          }
        }]), t;
      }(),
      Ve = Ye,
      Je = Ve;
    Ye.propTypes = {
      settings: i.a.object.isRequired,
      isOpen: i.a.bool.isRequired,
      selected: i.a.array,
      openSelect: i.a.func.isRequired,
      clearSelect: i.a.func.isRequired,
      toggleSelect: i.a.func.isRequired,
      selectedIndex: i.a.array.isRequired,
      options: i.a.array.isRequired,
      removeItem: i.a.func.isRequired,
      focused: i.a.bool.isRequired,
      ajax: i.a.object.isRequired,
      onRenderSelection: i.a.oneOfType([i.a.func, i.a.bool]),
      tags: i.a.object.isRequired
    }, "undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(Ye, "MultiHeader", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/MultiHeader/MultiHeader.js"), __REACT_HOT_LOADER__.register(Ve, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/MultiHeader/MultiHeader.js"));
    var Qe = function Qe(e) {
        return {
          settings: e.settings,
          selected: e.selected,
          selectedIndex: e.selectedIndex,
          options: e.options,
          isOpen: e.isOpen,
          focused: e.focused,
          ajax: e.ajax,
          onRenderSelection: e.onRenderSelection,
          tags: e.tags
        };
      },
      Ze = function Ze(e) {
        return {
          clearSelect: function clearSelect() {
            var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            t && (t.stopPropagation(), t.nativeEvent.stopImmediatePropagation()), e(ve());
          },
          removeItem: function removeItem(t) {
            e(ue(t));
          },
          openSelect: function openSelect() {
            e(Te());
          },
          toggleSelect: function toggleSelect() {
            e(xe());
          }
        };
      },
      Xe = Q(Qe, Ze)(Je),
      $e = Xe,
      et = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(Qe, "mapStateToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/MultiHeader/index.js"), __REACT_HOT_LOADER__.register(Ze, "mapDispatchToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/MultiHeader/index.js"), __REACT_HOT_LOADER__.register(Xe, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/MultiHeader/index.js")), function (e) {
        return e.active ? s.a.createElement("div", {
          className: "rs-search-prompt"
        }, "Please enter ", e.requiredLength, " or more characters") : null;
      }),
      tt = et,
      rt = tt;
    et.propTypes = {
      active: i.a.bool.isRequired,
      requiredLength: i.a.number.isRequired
    }, "undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(et, "SearchPrompt", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/SearchPrompt/SearchPrompt.js"), __REACT_HOT_LOADER__.register(tt, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/SearchPrompt/SearchPrompt.js"));
    var nt = function nt(e) {
        return {
          active: e.ajax.active && e.ajax.fetchOnSearch && e.ajax.searchPrompt && e.search.queryString.length < e.ajax.minLength,
          requiredLength: e.ajax.minLength - e.search.queryString.length
        };
      },
      st = Q(nt, void 0)(rt),
      ot = st,
      it = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(nt, "mapStateToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/SearchPrompt/index.js"), __REACT_HOT_LOADER__.register(st, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/SearchPrompt/index.js")), function (e) {
        return e.active ? s.a.createElement("div", {
          className: "rs-tag-wrapper" + (e.focused ? " focused" : ""),
          onClick: function onClick() {
            return e.createTag(e.tag);
          },
          ref: function ref(t) {
            return e.extractRef(t);
          }
        }, 'Create tag "', e.tag, '"') : null;
      });
    it.propTypes = {
      active: i.a.bool.isRequired,
      tag: i.a.string,
      createTag: i.a.func.isRequired,
      focused: i.a.bool.isRequired,
      extractRef: i.a.func.isRequired
    };
    var at = it,
      ct = at,
      lt = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(it, "Tags", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Tags/Tags.js"), __REACT_HOT_LOADER__.register(at, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Tags/Tags.js")), function (e) {
        return {
          active: e.tags.enabled && e.tags.active,
          tag: e.search.queryString,
          focused: e.tags.focused
        };
      }),
      pt = function pt(e) {
        return {
          createTag: function createTag(t) {
            e(pe(t));
          }
        };
      },
      ut = Q(lt, pt)(ct),
      dt = ut,
      ft = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(lt, "mapStateToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Tags/index.js"), __REACT_HOT_LOADER__.register(pt, "mapDispatchToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Tags/index.js"), __REACT_HOT_LOADER__.register(ut, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/Tags/index.js")), function (e) {
        return e.active ? s.a.createElement("li", {
          className: "rs-no-results"
        }, 'No results match "', e.queryString, '"') : null;
      });
    ft.propTypes = {
      active: i.a.bool.isRequired,
      queryString: i.a.string
    };
    var ht = ft,
      _t = ht,
      gt = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(ft, "NoResults", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/NoResults/NoResults.js"), __REACT_HOT_LOADER__.register(ht, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/NoResults/NoResults.js")), function (e, t) {
        return {
          active: 0 === t.options.length && e.search.queryString.length > 0 && (!e.ajax.active || e.ajax.minLength <= e.search.queryString.length && !e.ajax.fetching) && !e.tags.active,
          queryString: e.search.queryString
        };
      }),
      bt = Q(gt, void 0)(_t),
      mt = bt,
      xt = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(gt, "mapStateToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/NoResults/index.js"), __REACT_HOT_LOADER__.register(bt, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/partials/NoResults/index.js")), function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }()),
      yt = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);
          var r = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return ["buildOptionClassName", "handleBodyClick", "handleKeyDown", "handleMouseMove", "checkIfHovered", "maybeScroll"].forEach(function (e) {
            return r[e] = r[e].bind(r);
          }), r;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, s.a.Component), xt(t, [{
          key: "componentDidMount",
          value: function value() {
            document.addEventListener("click", this.handleBodyClick), document.addEventListener("touchstart", this.handleBodyClick), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("mousemove", this.handleMouseMove), !this.props.settings.multiple && !this.props.settings.commaSeperated && !this.props.settings.isDropDown && this.props.isOpen && this.props.checkForScroll && this.props.selected.length > 0 && this.props.maybeScroll(this.rsBodyRef, this["option-" + this.props.selectedIndex[0].toString()]);
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            document.removeEventListener("click", this.handleBodyClick), document.removeEventListener("touchstart", this.handleBodyClick), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("mousemove", this.handleMouseMove);
          }
        }, {
          key: "handleBodyClick",
          value: function value(e) {
            this.ref.contains(e.target) || (this.props.isOpen ? this.props.closeSelect(this.props.focused) : this.props.focused && this.props.blurSelect());
          }
        }, {
          key: "handleKeyDown",
          value: function value(e) {
            this.props.focused && this.props.handleKeyDown(e);
          }
        }, {
          key: "checkIfHovered",
          value: function value() {
            if (this.props.settings.stayOpen && this.props.settings.multiple && this.props.checkForHover && !this.props.settings.commaSeperated && !this.props.settings.checkBoxes && !this.props.settings.isDropDown && !this.props.tags.focused) for (var e = 0; e < this.props.options.length; e++) {
              var t = this["option-" + e];
              if (t && t.parentNode.querySelector(":hover") === t) {
                var r = this.rsBodyRef.scrollTop,
                  n = this.rsBodyRef.clientHeight,
                  s = this.rsBodyRef.scrollHeight;
                this.props.options[e] && 0 !== r && r + n >= s ? this.props.focusItem(e - 1, !0) : this.props.focusItem(e, !0);
                break;
              }
            }
          }
        }, {
          key: "maybeScroll",
          value: function value() {
            if (this.props.isOpen && this.props.checkForScroll) return this.props.tags.focused ? this.props.maybeScroll(this.rsBodyRef, this.tagsRef) : void (null !== this.props.focusedItem ? this.props.maybeScroll(this.rsBodyRef, this["option-" + this.props.focusedItemIndex.toString()]) : !this.props.settings.multiple && this.props.selected.length > 0 && this.props.maybeScroll(this.rsBodyRef, this["option-" + this.props.selectedIndex[0].toString()]));
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.checkIfHovered(), this.maybeScroll();
          }
        }, {
          key: "handleMouseMove",
          value: function value() {
            this.props.mouseEventLocked && this.props.unlockMouseFocus();
          }
        }, {
          key: "buildOptionClassName",
          value: function value(e) {
            var t = "rs-option";
            return e.hasOwnProperty("disabled") && !0 === e.disabled && (t += " disabled"), !this.props.settings.isDropDown && this.props.selected.includes(e.key) && (t += " selected"), null !== this.props.focusedItem && this.props.focusedItem === e.key && (t += " focused"), t.trim();
          }
        }, {
          key: "render",
          value: function value() {
            var e = this,
              t = this.props,
              r = t.options,
              n = t.settings,
              o = t.isOpen,
              i = t.selected,
              a = t.originalCount,
              c = t.ajax,
              l = t.onRenderOption,
              p = t.tags,
              u = t.queryString,
              d = se(n, o, i, p);
            return s.a.createElement("div", {
              className: "react-selectrix" + d,
              ref: function ref(t) {
                return e.ref = t;
              },
              onFocus: this.props.focusSelect
            }, s.a.createElement("input", {
              type: "hidden",
              value: JSON.stringify(i)
            }), s.a.createElement("div", {
              className: "rs-wrapper"
            }, n.multiple ? s.a.createElement($e, null) : s.a.createElement(Ge, null), (o || n.materialize) && s.a.createElement("div", {
              className: "rs-body" + (o ? "" : " hidden"),
              ref: function ref(t) {
                return e.rsBodyRef = t;
              },
              style: {
                maxHeight: this.props.height
              }
            }, s.a.createElement(dt, {
              extractRef: function extractRef(t) {
                return e.tagsRef = t;
              }
            }), n.selectAllButton && s.a.createElement("div", {
              className: "rs-toggle-wrapper"
            }, s.a.createElement("button", {
              type: "button",
              className: "rs-toggle-button",
              onClick: function onClick() {
                return a > i.length || c.fetchOnSearch ? e.props.selectAll() : e.props.clearSelect(!1, !0);
              }
            }, a > i.length || c.fetchOnSearch ? "Select All" : "Deselect All")), s.a.createElement(ot, null), s.a.createElement("ul", null, c.active && c.fetching && s.a.createElement("div", {
              className: "rs-loader"
            }, "Loading..."), s.a.createElement(mt, {
              options: r
            }), n.placeHolderInside && !n.multiple && (!c.active || !c.fetching && c.minLength <= u) && s.a.createElement("li", {
              onClick: this.props.clearSelect,
              className: this.buildOptionClassName({
                key: "default"
              }),
              onMouseEnter: function onMouseEnter() {
                return e.props.mouseEventLocked ? "" : e.props.focusItem(-1, !0);
              }
            }, n.placeholder), r.map(function (t, r) {
              var o = n.checkBoxes ? s.a.createElement("span", {
                className: "rs-checkbox-wrapper"
              }, s.a.createElement("input", {
                type: "checkbox",
                checked: e.props.selected.includes(t.key),
                readOnly: !0
              }), s.a.createElement("label", null, t.label)) : t.label;
              if (!1 !== l) {
                var i = l(t, r);
                i && (o = i);
              }
              return s.a.createElement("li", {
                ref: function ref(t) {
                  return e["option-" + r] = t;
                },
                onClick: function onClick(t) {
                  t.stopPropagation(), t.nativeEvent.stopImmediatePropagation(), e.props.selectItem(r);
                },
                key: "li-" + r,
                className: e.buildOptionClassName(t, r),
                onMouseOver: function onMouseOver() {
                  e.props.mouseEventLocked ? n.stayOpen && e.props.unlockMouseFocus() : e.props.focusItem(r, !0);
                }
              }, o);
            })))));
          }
        }]), t;
      }(),
      Ot = yt,
      Et = Ot;
    function vt(e) {
      if (Array.isArray(e)) {
        for (var t = 0, r = Array(e.length); t < e.length; t++) r[t] = e[t];
        return r;
      }
      return Array.from(e);
    }
    yt.propTypes = {
      settings: i.a.object.isRequired,
      toggleSelect: i.a.func.isRequired,
      options: i.a.array.isRequired,
      height: i.a.number.isRequired,
      isOpen: i.a.bool.isRequired,
      selected: i.a.array.isRequired,
      selectedIndex: i.a.array.isRequired,
      selectItem: i.a.func.isRequired,
      focusItem: i.a.func.isRequired,
      focusedItem: i.a.string,
      focusedItemIndex: i.a.number,
      clearSelect: i.a.func.isRequired,
      closeSelect: i.a.func.isRequired,
      focused: i.a.bool.isRequired,
      focusSelect: i.a.func.isRequired,
      blurSelect: i.a.func.isRequired,
      handleKeyDown: i.a.func.isRequired,
      maybeScroll: i.a.func.isRequired,
      checkForScroll: i.a.bool.isRequired,
      mouseEventLocked: i.a.bool.isRequired,
      unlockMouseFocus: i.a.func.isRequired,
      checkForHover: i.a.bool.isRequired,
      selectAll: i.a.func.isRequired,
      originalCount: i.a.number.isRequired,
      ajax: i.a.object.isRequired,
      onRenderOption: i.a.oneOfType([i.a.func, i.a.bool]),
      tags: i.a.object.isRequired,
      queryString: i.a.string.isRequired
    }, "undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(yt, "App", "D:/xampp/htdocs/react-selectrix/src/components/App/App.js"), __REACT_HOT_LOADER__.register(Ot, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/App.js"));
    var Tt = function Tt(e) {
        var t = e.search.queryString.toLowerCase(),
          r = e.search.active && "" !== t ? [].concat(vt(e.search.resultSet)) : [].concat(vt(e.options)),
          n = e.ajax.fetchOnSearch ? e.selected.map(function (e) {
            return e.key;
          }) : e.selected,
          s = e.options.length;
        return !e.settings.multiple || e.settings.commaSeperated || e.settings.checkBoxes || (r = r.filter(function (e) {
          return !n.includes(e.key);
        })), {
          settings: e.settings,
          selected: n,
          selectedIndex: e.selectedIndex,
          isOpen: e.isOpen,
          options: r,
          focused: e.focused,
          focusedItem: e.focusedItem,
          focusedItemIndex: e.focusedItemIndex,
          checkForScroll: e.checkForScroll,
          mouseEventLocked: e.mouseEventLocked,
          checkForHover: e.checkForHover,
          originalCount: s,
          height: e.height,
          ajax: e.ajax,
          onRenderOption: e.onRenderOption,
          tags: e.tags,
          queryString: t
        };
      },
      St = function St(e) {
        return {
          toggleSelect: function toggleSelect() {
            e(xe());
          },
          selectItem: function selectItem(t) {
            e(Ee(t));
          },
          focusItem: function focusItem(t) {
            var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            e(we(t, r));
          },
          openSelect: function openSelect() {
            e(Te());
          },
          clearSelect: function clearSelect() {
            var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            t && (t.stopPropagation(), t.nativeEvent.stopImmediatePropagation()), e(ve(r));
          },
          closeSelect: function closeSelect() {
            var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            e(Re(t));
          },
          focusSelect: function focusSelect() {
            e(function (e, t) {
              t().focused || e({
                type: "FOCUS_SELECT"
              });
            });
          },
          blurSelect: function blurSelect() {
            e({
              type: "BLUR_SELECT"
            });
          },
          handleKeyDown: function handleKeyDown(t) {
            e(Ae(t));
          },
          maybeScroll: function maybeScroll(t, r) {
            e(Ce(t, r));
          },
          unlockMouseFocus: function unlockMouseFocus() {
            e({
              type: "UNLOCK_MOUSE_FOCUS"
            });
          },
          selectAll: function selectAll() {
            e(Oe());
          }
        };
      },
      Rt = Q(Tt, St)(Et),
      At = Rt,
      jt = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(Tt, "mapStateToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/index.js"), __REACT_HOT_LOADER__.register(St, "mapDispatchToProps", "D:/xampp/htdocs/react-selectrix/src/components/App/index.js"), __REACT_HOT_LOADER__.register(Rt, "default", "D:/xampp/htdocs/react-selectrix/src/components/App/index.js")), function () {
        function e(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        return function (t, r, n) {
          return r && e(t.prototype, r), n && e(t, n), t;
        };
      }()),
      Ct = function (e) {
        function t(e) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);
          var r = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return ["handleMouseMove"].forEach(function (e) {
            return r[e] = r[e].bind(r);
          }), r.ref = null, r.rsBodyRef = null, r;
        }
        return function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
        }(t, s.a.Component), jt(t, [{
          key: "handleMouseMove",
          value: function value() {
            this.state.mouseEventLocked && this.setState({
              mouseEventLocked: !1
            });
          }
        }, {
          key: "componentWillMount",
          value: function value() {
            this.props.setupInstance(this.props);
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            this.props.updateInstance(e);
          }
        }, {
          key: "render",
          value: function value() {
            return s.a.createElement(At, null);
          }
        }]), t;
      }(),
      wt = Ct,
      Dt = wt;
    Ct.defaultProps = {
      id: "",
      options: [],
      height: 190,
      className: "",
      isOpen: !1,
      placeHolderInside: !1,
      placeholder: "Please Select",
      arrow: !0,
      defaultValue: !1,
      multiple: !1,
      disabled: !1,
      searchIndex: !0,
      onChange: function onChange() {},
      onOpen: function onOpen() {},
      onClose: function onClose() {},
      customScrollbar: !1,
      searchable: !0,
      stayOpen: !1,
      initialized: !1,
      commaSeperated: !1,
      singleLine: !1,
      lifo: !1,
      selectAllButton: !1,
      checkBoxes: !1,
      materialize: !1,
      isDropDown: !1,
      customKeys: !1,
      ajax: !1,
      onRenderOption: !1,
      onRenderSelection: !1,
      tags: !1,
      updateInstance: function updateInstance() {}
    }, Ct.propTypes = {
      options: i.a.array.isRequired,
      id: i.a.string.isRequired,
      height: i.a.oneOfType([i.a.number, i.a.string]),
      className: i.a.string,
      isOpen: i.a.bool,
      placeHolderInside: i.a.bool,
      placeholder: i.a.string,
      arrow: i.a.bool,
      defaultValue: i.a.oneOfType([i.a.string, i.a.array, i.a.bool]),
      multiple: i.a.bool,
      disabled: i.a.bool,
      searchIndex: i.a.bool,
      onChange: i.a.func,
      customScrollbar: i.a.bool,
      searchable: i.a.bool,
      stayOpen: i.a.bool,
      commaSeperated: i.a.bool,
      singleLine: i.a.bool,
      lifo: i.a.bool,
      selectAllButton: i.a.bool,
      checkBoxes: i.a.bool,
      materialize: i.a.bool,
      isDropDown: i.a.bool,
      customKeys: i.a.oneOfType([i.a.object, i.a.bool]),
      ajax: i.a.oneOfType([i.a.object, i.a.bool]),
      onRenderOption: i.a.oneOfType([i.a.func, i.a.bool]),
      onRenderSelection: i.a.oneOfType([i.a.func, i.a.bool]),
      tags: i.a.bool,
      setupInstance: i.a.func.isRequired,
      updateInstance: i.a.func.isRequired
    }, "undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(Ct, "Selectrix", "D:/xampp/htdocs/react-selectrix/src/components/Selectrix.js"), __REACT_HOT_LOADER__.register(wt, "default", "D:/xampp/htdocs/react-selectrix/src/components/Selectrix.js"));
    var Lt = 0,
      kt = function kt(e, t) {
        return t;
      },
      It = function It(e) {
        return {
          setupInstance: function setupInstance(t) {
            e(de(Object.assign({}, t, {
              id: "selectrix_instance_" + Lt
            }))), Lt++;
          },
          updateInstance: function updateInstance(t) {
            e(de(t, !0));
          }
        };
      },
      Pt = Q(kt, It)(Dt),
      Ht = Pt,
      Nt = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(Lt, "index", "D:/xampp/htdocs/react-selectrix/src/components/index.js"), __REACT_HOT_LOADER__.register(kt, "mapStateToProps", "D:/xampp/htdocs/react-selectrix/src/components/index.js"), __REACT_HOT_LOADER__.register(It, "mapDispatchToProps", "D:/xampp/htdocs/react-selectrix/src/components/index.js"), __REACT_HOT_LOADER__.register(Pt, "default", "D:/xampp/htdocs/react-selectrix/src/components/index.js")), r(5)),
      qt = r.n(Nt);
    function Ut(e) {
      if (Array.isArray(e)) {
        for (var t = 0, r = Array(e.length); t < e.length; t++) r[t] = e[t];
        return r;
      }
      return Array.from(e);
    }
    var Mt = {
        settings: {
          className: "",
          placeHolderInside: !0,
          placeholder: "Please Select",
          arrow: !0,
          multiple: !1,
          disabled: !1,
          searchIndex: !0,
          customScrollbar: !1,
          searchable: !0,
          commaSeperated: !1,
          singleLine: !1,
          lifo: !1,
          selectAllButton: !1,
          checkBoxes: !1,
          materialize: !1,
          isDropDown: !1
        },
        options: [],
        height: "150",
        isOpen: !1,
        selected: [],
        selectedIndex: [],
        customKeys: !1,
        initialized: !1,
        focused: !1,
        focusedItem: null,
        focusedItemIndex: null,
        mouseEventLocked: !1,
        checkForScroll: !1,
        checkForHover: !1,
        tags: {
          enabled: !1,
          active: !1,
          focused: !1,
          tagSet: []
        },
        scrolled: {
          active: !1,
          scroll: 0
        },
        search: {
          active: !1,
          queryString: "",
          resultSet: []
        },
        ajax: !1,
        onChange: function onChange() {},
        onOpen: function onOpen() {},
        onClose: function onClose() {}
      },
      Ft = function Ft() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Mt,
          t = arguments[1];
        switch (t.type) {
          case "FOCUS_TAG":
            return Object.assign({}, e, {
              tags: Object.assign({}, e.tags, {
                focused: !0
              }),
              focusedItem: null,
              focusedItemIndex: null,
              checkForScroll: !0
            });
          case "CREATE_TAG":
            return Object.assign({}, e, {
              options: t.options,
              search: Object.assign({}, e.search, {
                resultSet: t.resultSet
              }),
              tags: Object.assign({}, e.tags, {
                tagSet: [].concat(Ut(e.tags.tagSet), [t.tag])
              })
            });
          case "SELECT_ALL":
            var r = e.ajax.fetchOnSearch ? e.selected.map(function (e) {
                return e.key;
              }) : e.selected,
              n = e.search.active ? [].concat(Ut(e.search.resultSet)) : [].concat(Ut(e.options));
            n = n.filter(function (e) {
              return !r.includes(e.key);
            });
            var s = [].concat(Ut(n)).map(function (e) {
                return e.key;
              }),
              o = e.ajax.fetchOnSearch ? n : s,
              i = [].concat(Ut(e.options)).map(function (e, t) {
                return s.includes(e.key) ? t : null;
              }).filter(function (e) {
                return null !== e;
              });
            return e.settings.lifo && (o = o.reverse(), i = i.reverse()), Object.assign({}, e, {
              selected: e.settings.lifo ? [].concat(Ut(o), Ut(e.selected)) : [].concat(Ut(e.selected), Ut(o)),
              selectedIndex: e.settings.lifo ? [].concat(Ut(i), Ut(e.selectedIndex)) : [].concat(Ut(e.selectedIndex), Ut(i))
            });
          case "REMOVE_ITEM":
            return Object.assign({}, e, {
              selected: e.ajax.active && e.ajax.fetchOnSearch ? [].concat(Ut(e.selected)).filter(function (e) {
                return e.key !== t.index;
              }) : [].concat(Ut(e.selected)).filter(function (r) {
                return r !== e.options[t.index].key;
              }),
              selectedIndex: [].concat(Ut(e.selectedIndex)).filter(function (e) {
                return e !== t.index;
              })
            });
          case "SET_QUERY_STRING":
            return Object.assign({}, e, {
              search: Object.assign({}, e.search, {
                active: !0,
                queryString: t.queryString,
                resultSet: []
              }),
              ajax: Object.assign({}, e.ajax, {
                fetching: t.queryString.length >= e.ajax.minLength
              }),
              options: []
            });
          case "SETUP_INSTANCE":
          case "UPDATE_INSTANCE":
            return Object.assign({}, e, {
              settings: Object.assign({}, e.settings, {
                className: t.props.className,
                placeHolderInside: !t.props.multiple && t.props.placeHolderInside,
                placeholder: t.props.placeholder,
                arrow: t.props.arrow,
                multiple: t.props.multiple,
                disabled: t.props.disabled,
                searchIndex: t.props.searchIndex,
                customScrollbar: t.props.customScrollbar,
                searchable: t.props.searchable,
                stayOpen: t.props.hasOwnProperty("stayOpen") ? t.props.stayOpen && !t.props.isDropDown : !!t.props.multiple,
                commaSeperated: t.props.multiple && t.props.commaSeperated,
                singleLine: t.props.singleLine,
                lifo: t.props.multiple && t.props.lifo,
                selectAllButton: t.props.multiple && t.props.selectAllButton,
                checkBoxes: t.props.checkBoxes,
                materialize: t.props.materialize,
                isDropDown: t.props.isDropDown && !t.props.multiple
              }),
              options: "UPDATE_INSTANCE" === t.type && e.ajax.active && e.settings.multiple === t.props.multiple ? e.options : t.options,
              height: t.props.height,
              isOpen: t.props.isOpen ? t.props.isOpen : "UPDATE_INSTANCE" === t.type && e.isOpen,
              selected: "UPDATE_INSTANCE" === t.type && e.ajax.active && e.settings.multiple === t.props.multiple ? e.selected : t.selected,
              selectedIndex: "UPDATE_INSTANCE" === t.type && e.ajax.active && e.settings.multiple === t.props.multiple ? e.selectedIndex : t.selectedIndex,
              customKeys: t.customKeys,
              ajax: t.ajax,
              initialized: !0,
              onChange: t.props.onChange,
              onOpen: t.props.onOpen,
              onClose: t.props.onClose,
              checkForScroll: "UPDATE_INSTANCE" === t.type ? e.isOpen : t.props.isOpen,
              onRenderOption: t.props.onRenderOption,
              onRenderSelection: t.props.onRenderSelection,
              tags: Object.assign({}, e.tags, {
                enabled: t.props.tags
              }),
              id: t.props.id
            });
          case "SET_TAG":
            return Object.assign({}, e, {
              tags: Object.assign({}, e.tags, {
                enabled: e.tags.enabled,
                active: e.tags.enabled && t.tag.length > 0 && t.tag.trim() && void 0 === e.options.find(function (e) {
                  return e.label === t.tag;
                })
              }),
              search: Object.assign({}, e.search, {
                queryString: t.tag
              })
            });
          case "SEARCH_OPTIONS":
            var a = t.queryString.toLowerCase();
            return Object.assign({}, e, {
              search: Object.assign({}, e.search, {
                active: !0,
                queryString: t.queryString,
                resultSet: e.ajax.active && e.ajax.fetchOnSearch ? t.queryString.length < e.ajax.minLength ? [] : e.options : e.options.filter(function (t) {
                  return t.label.toLowerCase().includes(a) || e.settings.searchIndex && t.key.toString().toLowerCase().includes(a);
                })
              }),
              focusedItem: null,
              focusedItemIndex: null,
              tags: Object.assign({}, e.tags, {
                enabled: e.tags.enabled,
                active: e.tags.enabled && t.queryString.length > 0 && t.queryString.trim() && void 0 === e.options.find(function (e) {
                  return e.label === t.queryString;
                })
              })
            });
          case "CHECK_FOR_SCROLL":
            return Object.assign({}, e, {
              checkForScroll: !0
            });
          case "CLEAR_SEARCH":
            return Object.assign({}, e, {
              search: Mt.search,
              focusedItem: null,
              focusedItemIndex: null,
              options: e.ajax.active && e.ajax.fetchOnSearch ? [] : e.options,
              tags: Object.assign({}, e.tags, {
                enabled: e.tags.enabled,
                active: !1
              })
            });
          case "CLOSE_SELECT":
            return Object.assign({}, e, {
              isOpen: !1,
              focusedItem: null,
              focusedItemIndex: null,
              search: Mt.search,
              options: e.ajax.fetchOnSearch && e.settings.multiple ? [] : e.options,
              ajax: Object.assign({}, e.ajax, {
                fetching: !1
              }),
              tags: Object.assign({}, e.tags, {
                enabled: e.tags.enabled,
                active: !1
              }),
              focused: !t.blur && e.focused
            });
          case "OPEN_SELECT":
            return Object.assign({}, e, {
              isOpen: !0,
              checkForScroll: !0
            });
          case "CLEAR_SELECT":
            return Object.assign({}, e, {
              selected: [],
              selectedIndex: [],
              focusedItem: null,
              focusedItemIndex: null,
              search: t.stayOpen ? e.search : Mt.search,
              options: e.ajax.fetchOnSearch ? [] : e.options,
              tags: Object.assign({}, e.tags, {
                enabled: e.tags.enabled,
                active: !1
              })
            });
          case "FOCUS_SELECT":
            return Object.assign({}, e, {
              focused: !0
            });
          case "BLUR_SELECT":
            return Object.assign({}, e, {
              focused: !1
            });
          case "SELECT_ITEM":
            return Object.assign({}, e, {
              selected: e.settings.multiple ? e.settings.lifo ? [e.ajax.active && e.ajax.fetchOnSearch ? t.item : t.item.key].concat(Ut(e.selected)) : [].concat(Ut(e.selected), [e.ajax.active && e.ajax.fetchOnSearch ? t.item : t.item.key]) : [t.item.key],
              selectedIndex: e.settings.multiple ? e.settings.lifo ? [t.index].concat(Ut(e.selectedIndex)) : [].concat(Ut(e.selectedIndex), [t.index]) : [t.index],
              focusedItem: e.settings.stayOpen && e.selected.length < e.options.length - 1 ? e.focusedItem : null,
              focusedItemIndex: e.settings.stayOpen && e.selected.length < e.options.length - 1 ? e.focusedItemIndex : null,
              mouseEventLocked: e.settings.stayOpen,
              checkForHover: e.settings.stayOpen && !t.isKeyboard,
              search: e.settings.stayOpen && e.settings.searchable ? e.search : Mt.search,
              tags: Object.assign({}, e.tags, {
                enabled: e.tags.enabled,
                active: !1
              })
            });
          case "FOCUS_ITEM":
            return Object.assign({}, e, {
              focusedItem: t.item.key,
              focusedItemIndex: t.index,
              mouseEventLocked: !t.mouseEvent,
              checkForScroll: !t.mouseEvent,
              checkForHover: !1,
              tags: Object.assign({}, e.tags, {
                focused: !1
              })
            });
          case "UNLOCK_MOUSE_FOCUS":
            return Object.assign({}, e, {
              mouseEventLocked: !1,
              checkForScroll: !1,
              checkForHover: !1
            });
          case "SCROLL_SELECT":
            return Object.assign({}, e, {
              checkForScroll: !1,
              scrolled: Object.assign({}, e.scrolled, {
                active: t.active,
                scroll: t.scroll
              })
            });
          case "FETCHING_OPTIONS":
            return Object.assign({}, e, {
              ajax: Object.assign({}, e.ajax, {
                fetching: !0
              })
            });
          case "SETUP_AJAX_OPTIONS":
            return Object.assign({}, e, {
              options: t.options,
              ajax: Object.assign({}, e.ajax, {
                fetching: !1,
                needsUpdate: !1
              }),
              search: e.ajax.fetchOnSearch ? Object.assign({}, e.search, {}, {
                active: !0,
                resultSet: t.options
              }) : e.search
            });
          case "CLEAR_OPTIONS":
            return Object.assign({}, e, {
              options: [],
              ajax: Object.assign({}, e.ajax, {
                fetching: !0
              }),
              search: Object.assign({}, e.search, {
                resultSet: []
              })
            });
          default:
            return e;
        }
      },
      Bt = Ft,
      zt = Bt,
      Kt = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(Mt, "initialState", "D:/xampp/htdocs/react-selectrix/src/reducers/index.js"), __REACT_HOT_LOADER__.register(Ft, "reducer", "D:/xampp/htdocs/react-selectrix/src/reducers/index.js"), __REACT_HOT_LOADER__.register(Bt, "default", "D:/xampp/htdocs/react-selectrix/src/reducers/index.js")), function (e) {
        var t = C(zt, function () {
          for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) t[r] = arguments[r];
          return function (e) {
            return function () {
              for (var r = arguments.length, n = Array(r), s = 0; s < r; s++) n[s] = arguments[s];
              var o = e.apply(void 0, n),
                i = function i() {
                  throw new Error("Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
                },
                a = {
                  getState: o.getState,
                  dispatch: function dispatch() {
                    return i.apply(void 0, arguments);
                  }
                },
                c = t.map(function (e) {
                  return e(a);
                });
              return i = function () {
                for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                return 0 === t.length ? function (e) {
                  return e;
                } : 1 === t.length ? t[0] : t.reduce(function (e, t) {
                  return function () {
                    return e(t.apply(void 0, arguments));
                  };
                });
              }.apply(void 0, c)(o.dispatch), j({}, o, {
                dispatch: i
              });
            };
          };
        }(qt.a));
        return s.a.createElement(l, {
          store: t
        }, s.a.createElement(Ht, e));
      }),
      Gt = Kt,
      Wt = Gt,
      Yt = ("undefined" != typeof __REACT_HOT_LOADER__ && (__REACT_HOT_LOADER__.register(Kt, "ReduxStore", "D:/xampp/htdocs/react-selectrix/src/store/productionStore.js"), __REACT_HOT_LOADER__.register(Gt, "default", "D:/xampp/htdocs/react-selectrix/src/store/productionStore.js")), Wt);
    t.default = Yt, "undefined" != typeof __REACT_HOT_LOADER__ && __REACT_HOT_LOADER__.register(Yt, "default", "D:/xampp/htdocs/react-selectrix/src/index.js");
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" != typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" != typeof e) return e;
      var r = t.protocol + "//" + t.host,
        n = r + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var s,
          o = t.trim().replace(/^"(.*)"$/, function (e, t) {
            return t;
          }).replace(/^'(.*)'$/, function (e, t) {
            return t;
          });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(o) ? e : (s = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? r + o : n + o.replace(/^\.\//, ""), "url(" + JSON.stringify(s) + ")");
      });
    };
  }, function (e, t, r) {
    var n,
      s,
      o = {},
      i = (n = function n() {
        return window && document && document.all && !window.atob;
      }, function () {
        return void 0 === s && (s = n.apply(this, arguments)), s;
      }),
      a = function (e) {
        var t = {};
        return function (e) {
          if (void 0 === t[e]) {
            var r = function (e) {
              return document.querySelector(e);
            }.call(this, e);
            if (r instanceof window.HTMLIFrameElement) try {
              r = r.contentDocument.head;
            } catch (e) {
              r = null;
            }
            t[e] = r;
          }
          return t[e];
        };
      }(),
      c = null,
      l = 0,
      p = [],
      u = r(9);
    function d(e, t) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r],
          s = o[n.id];
        if (s) {
          s.refs++;
          for (var i = 0; i < s.parts.length; i++) s.parts[i](n.parts[i]);
          for (; i < n.parts.length; i++) s.parts.push(m(n.parts[i], t));
        } else {
          var a = [];
          for (i = 0; i < n.parts.length; i++) a.push(m(n.parts[i], t));
          o[n.id] = {
            id: n.id,
            refs: 1,
            parts: a
          };
        }
      }
    }
    function f(e, t) {
      for (var r = [], n = {}, s = 0; s < e.length; s++) {
        var o = e[s],
          i = t.base ? o[0] + t.base : o[0],
          a = {
            css: o[1],
            media: o[2],
            sourceMap: o[3]
          };
        n[i] ? n[i].parts.push(a) : r.push(n[i] = {
          id: i,
          parts: [a]
        });
      }
      return r;
    }
    function h(e, t) {
      var r = a(e.insertInto);
      if (!r) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var n = p[p.length - 1];
      if ("top" === e.insertAt) n ? n.nextSibling ? r.insertBefore(t, n.nextSibling) : r.appendChild(t) : r.insertBefore(t, r.firstChild), p.push(t);else if ("bottom" === e.insertAt) r.appendChild(t);else {
        if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var s = a(e.insertInto + " " + e.insertAt.before);
        r.insertBefore(t, s);
      }
    }
    function _(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = p.indexOf(e);
      t >= 0 && p.splice(t, 1);
    }
    function g(e) {
      var t = document.createElement("style");
      return e.attrs.type = "text/css", b(t, e.attrs), h(e, t), t;
    }
    function b(e, t) {
      Object.keys(t).forEach(function (r) {
        e.setAttribute(r, t[r]);
      });
    }
    function m(e, t) {
      var r, n, s, o;
      if (t.transform && e.css) {
        if (!(o = t.transform(e.css))) return function () {};
        e.css = o;
      }
      if (t.singleton) {
        var i = l++;
        r = c || (c = g(t)), n = O.bind(null, r, i, !1), s = O.bind(null, r, i, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (r = function (e) {
        var t = document.createElement("link");
        return e.attrs.type = "text/css", e.attrs.rel = "stylesheet", b(t, e.attrs), h(e, t), t;
      }(t), n = function (e, t, r) {
        var n = r.css,
          s = r.sourceMap,
          o = void 0 === t.convertToAbsoluteUrls && s;
        (t.convertToAbsoluteUrls || o) && (n = u(n)), s && (n += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(s)))) + " */");
        var i = new Blob([n], {
            type: "text/css"
          }),
          a = e.href;
        e.href = URL.createObjectURL(i), a && URL.revokeObjectURL(a);
      }.bind(null, r, t), s = function s() {
        _(r), r.href && URL.revokeObjectURL(r.href);
      }) : (r = g(t), n = function (e, t) {
        var r = t.css,
          n = t.media;
        if (n && e.setAttribute("media", n), e.styleSheet) e.styleSheet.cssText = r;else {
          for (; e.firstChild;) e.removeChild(e.firstChild);
          e.appendChild(document.createTextNode(r));
        }
      }.bind(null, r), s = function s() {
        _(r);
      });
      return n(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          n(e = t);
        } else s();
      };
    }
    e.exports = function (e, t) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = i()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var r = f(e, t);
      return d(r, t), function (e) {
        for (var n = [], s = 0; s < r.length; s++) {
          var i = r[s];
          (a = o[i.id]).refs--, n.push(a);
        }
        for (e && d(f(e, t), t), s = 0; s < n.length; s++) {
          var a;
          if (0 === (a = n[s]).refs) {
            for (var c = 0; c < a.parts.length; c++) a.parts[c]();
            delete o[a.id];
          }
        }
      };
    };
    var x,
      y = (x = [], function (e, t) {
        return x[e] = t, x.filter(Boolean).join("\n");
      });
    function O(e, t, r, n) {
      var s = r ? "" : n.css;
      if (e.styleSheet) e.styleSheet.cssText = y(t, s);else {
        var o = document.createTextNode(s),
          i = e.childNodes;
        i[t] && e.removeChild(i[t]), i.length ? e.insertBefore(o, i[t]) : e.appendChild(o);
      }
    }
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var r = function (e, t) {
            var r,
              n = e[1] || "",
              s = e[3];
            if (!s) return n;
            if (t && "function" == typeof btoa) {
              var o = (r = s, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */"),
                i = s.sources.map(function (e) {
                  return "/*# sourceURL=" + s.sourceRoot + e + " */";
                });
              return [n].concat(i).concat([o]).join("\n");
            }
            return [n].join("\n");
          }(t, e);
          return t[2] ? "@media " + t[2] + "{" + r + "}" : r;
        }).join("");
      }, t.i = function (e, r) {
        "string" == typeof e && (e = [[null, e, ""]]);
        for (var n = {}, s = 0; s < this.length; s++) {
          var o = this[s][0];
          "number" == typeof o && (n[o] = !0);
        }
        for (s = 0; s < e.length; s++) {
          var i = e[s];
          "number" == typeof i[0] && n[i[0]] || (r && !i[2] ? i[2] = r : r && (i[2] = "(" + i[2] + ") and (" + r + ")"), t.push(i));
        }
      }, t;
    };
  }, function (e, t, r) {
    (e.exports = r(11)(!1)).push([e.i, '.react-selectrix {\n  position: relative; }\n  .react-selectrix *, .react-selectrix ::after, .react-selectrix ::before {\n    box-sizing: border-box; }\n  .react-selectrix .hidden {\n    display: none; }\n  .react-selectrix .clearfix:after, .react-selectrix .clearfix:before {\n    content: "";\n    display: table; }\n  .react-selectrix .clearfix:after {\n    clear: both; }\n  .react-selectrix .rs-toggle-wrapper, .react-selectrix .rs-search-prompt {\n    padding: 11px 20px;\n    font-size: 11px;\n    color: #92a2b9; }\n  .react-selectrix .rs-tag-wrapper {\n    padding: 11px 20px;\n    font-size: 12px;\n    cursor: pointer;\n    color: #6a7f9d;\n    box-shadow: 0 0px 4px rgba(0, 0, 0, 0.1); }\n    .react-selectrix .rs-tag-wrapper:hover, .react-selectrix .rs-tag-wrapper:focus, .react-selectrix .rs-tag-wrapper:active {\n      background-color: #faf7f7; }\n    .react-selectrix .rs-tag-wrapper.focused {\n      background-color: #faf7f7; }\n  .react-selectrix input#searchable.rs-active {\n    min-width: 30px; }\n  .react-selectrix button.rs-toggle-button {\n    background-color: #ffffff;\n    border: none;\n    font-size: 11px;\n    cursor: pointer;\n    outline: none;\n    color: #92a2b9;\n    padding: 0; }\n    .react-selectrix button.rs-toggle-button:hover {\n      text-decoration: underline; }\n  .react-selectrix .vertical-align:before {\n    content: \'\';\n    display: inline-block;\n    height: 100%;\n    vertical-align: middle;\n    margin-right: 0; }\n  .react-selectrix .vertical-align > * {\n    display: inline-block;\n    vertical-align: middle; }\n  .react-selectrix .rs-header {\n    border: 1px solid #bdc8d5;\n    color: #6a7f9d;\n    border-radius: 2px;\n    background-color: #ffffff;\n    position: relative;\n    font-size: 14px;\n    margin: 0;\n    user-select: none; }\n    .react-selectrix .rs-header ::-webkit-input-placeholder {\n      color: #6a7f9d; }\n    .react-selectrix .rs-header ::-moz-placeholder {\n      color: #6a7f9d; }\n    .react-selectrix .rs-header :-ms-input-placeholder {\n      color: #6a7f9d; }\n    .react-selectrix .rs-header :-moz-placeholder {\n      color: #6a7f9d; }\n  .react-selectrix.rs-base-arrow .rs-reset-wrapper {\n    right: 25px; }\n  .react-selectrix.rs-base-customscrollbar ::-webkit-scrollbar {\n    width: 12px;\n    height: 12px; }\n  .react-selectrix.rs-base-customscrollbar ::-webkit-scrollbar-thumb {\n    background: #6f747b; }\n  .react-selectrix.rs-base-customscrollbar ::-webkit-scrollbar-track {\n    background: #dfdfdf; }\n  .react-selectrix.rs-base-disabled {\n    opacity: 0.6;\n    pointer-events: none; }\n  .react-selectrix.rs-base-searchable .rs-header, .react-selectrix.rs-base-tags .rs-header {\n    padding: 0; }\n  .react-selectrix.rs-base-searchable .rs-toggle, .react-selectrix.rs-base-tags .rs-toggle {\n    cursor: text; }\n  .react-selectrix.rs-base-singleline .rs-toggle {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: block; }\n  .react-selectrix.rs-base-multiple:not(.rs-base-empty):not(.rs-base-commaseperated) .rs-toggle {\n    padding: 5px 50px 5px 5px; }\n  .react-selectrix.rs-base-multiple.rs-base-commaseperated:not(.rs-base-empty) .rs-toggle {\n    padding: 7px 50px 7px 15px;\n    line-height: 1.8; }\n  .react-selectrix.rs-base-multiple.rs-base-commaseperated.rs-base-searchable .rs-toggle {\n    display: flex; }\n  .react-selectrix.rs-base-multiple.rs-base-commaseperated.rs-base-searchable .rs-commaseperated-wrapper {\n    display: block;\n    padding-right: 10px;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis; }\n  .react-selectrix.rs-base-multiple .rs-selection {\n    display: inline-block;\n    background-color: #00B2EE;\n    padding: 3px 10px 3px 25px;\n    color: #ffffff;\n    margin: 2px;\n    font-size: 12px;\n    border-radius: 2px;\n    border: 1px solid #21a4cf;\n    position: relative;\n    cursor: pointer;\n    max-width: 100%;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden; }\n  .react-selectrix.rs-base-multiple:not(.rs-base-empty) .rs-selection, .react-selectrix.rs-base-multiple:not(.rs-base-empty) .rs-searchable {\n    vertical-align: middle; }\n  .react-selectrix.rs-base-multiple .rs-remove {\n    font-size: 15px;\n    color: #fff3f3;\n    position: absolute;\n    left: 0;\n    width: 20px;\n    text-align: center;\n    border-right: 1px solid #d9d6d6;\n    top: 0;\n    height: 100%;\n    transition: 0.2s background-color ease-in-out;\n    font-family: "Arial" !important; }\n    .react-selectrix.rs-base-multiple .rs-remove:hover {\n      background-color: #23c8ff; }\n  .react-selectrix.rs-base-multiple .rs-searchable {\n    border: none;\n    box-shadow: none;\n    outline: none;\n    -webkit-appearance: none;\n    max-width: 100%;\n    color: #6a7f9d;\n    padding: 0;\n    font-size: 14px; }\n  .react-selectrix .rs-reset {\n    font-size: 20px;\n    color: #6a7f9d;\n    position: relative;\n    top: 1px;\n    font-family: "Arial" !important; }\n    .react-selectrix .rs-reset:hover {\n      color: #b90e0e; }\n  .react-selectrix .rs-arrow-wrapper {\n    position: absolute;\n    width: 10px;\n    height: 100%;\n    top: 0;\n    right: 10px; }\n  .react-selectrix .rs-reset-wrapper {\n    position: absolute;\n    width: 10px;\n    height: 100%;\n    top: 0;\n    right: 10px;\n    cursor: pointer; }\n    .react-selectrix .rs-reset-wrapper:before {\n      margin-right: -0.15em; }\n  .react-selectrix .rs-arrow-indicator {\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 5px 5px 0 5px;\n    border-color: #6a7f9d transparent transparent;\n    transition: 0.1s transform ease-in-out; }\n    .react-selectrix .rs-arrow-indicator.up {\n      transform: rotate(180deg); }\n  .react-selectrix .rs-body {\n    border-radius: 2px;\n    background-color: #ffffff;\n    box-shadow: 0 3px 7px 0 rgba(139, 155, 175, 0.5);\n    position: absolute;\n    width: 100%;\n    left: 0;\n    z-index: 1;\n    overflow: auto; }\n    .react-selectrix .rs-body > ul {\n      list-style-type: none;\n      padding: 0;\n      margin: 0;\n      overflow: hidden; }\n  .react-selectrix .rs-option {\n    cursor: pointer;\n    padding: 11px 20px;\n    color: #6a7f9d;\n    font-size: 14px;\n    user-select: none;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: normal; }\n    .react-selectrix .rs-option.disabled {\n      opacity: 0.6;\n      pointer-events: none; }\n    .react-selectrix .rs-option:not(.disabled).focused {\n      background-color: #faf7f7; }\n    .react-selectrix .rs-option:not(.disabled).selected {\n      background-color: #eeeeee; }\n  .react-selectrix .rs-no-results {\n    padding: 11px 20px;\n    color: #6a7f9d;\n    font-size: 12px; }\n  .react-selectrix .rs-toggle {\n    border: none;\n    outline: none;\n    padding: 10px 50px 10px 15px;\n    width: 100%;\n    cursor: pointer;\n    color: #6a7f9d;\n    font-size: 14px;\n    line-height: normal; }\n    .react-selectrix .rs-toggle.rs-focused {\n      outline: 0;\n      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(81, 152, 209, 0.6); }\n    .react-selectrix .rs-toggle.rs-searchable:focus {\n      cursor: text; }\n  .react-selectrix.rs-base-checkboxes .rs-option:not(.disabled).selected {\n    background-color: inherit; }\n  .react-selectrix.rs-base-checkboxes .rs-option:not(.disabled).focused {\n    background-color: #faf7f7; }\n  .react-selectrix.rs-base-checkboxes .rs-option input[type="checkbox"] {\n    position: absolute;\n    opacity: 0;\n    margin: 0; }\n    .react-selectrix.rs-base-checkboxes .rs-option input[type="checkbox"]:not(:checked) + label:before {\n      width: 0;\n      height: 0;\n      border: 3px solid transparent;\n      left: 6px;\n      top: 10px;\n      -webkit-transform: rotateZ(37deg);\n      transform: rotateZ(37deg);\n      -webkit-transform-origin: 100% 100%;\n      transform-origin: 100% 100%; }\n    .react-selectrix.rs-base-checkboxes .rs-option input[type="checkbox"]:not(:checked) + label:after {\n      height: 13px;\n      width: 13px;\n      background-color: transparent;\n      border: 1px solid #D5D9DF;\n      border-radius: 2px;\n      top: 0;\n      z-index: 0; }\n    .react-selectrix.rs-base-checkboxes .rs-option input[type="checkbox"] + label {\n      position: relative;\n      padding-left: 25px;\n      cursor: pointer;\n      display: inline-block;\n      user-select: none;\n      font-size: 14px;\n      line-height: 14px;\n      font-weight: 400;\n      margin-bottom: 0; }\n      .react-selectrix.rs-base-checkboxes .rs-option input[type="checkbox"] + label:after, .react-selectrix.rs-base-checkboxes .rs-option input[type="checkbox"] + label:before {\n        content: \'\';\n        left: 0;\n        position: absolute;\n        -webkit-transition: border 0.25s, background-color 0.25s, width 0.20s 0.1s, height 0.20s 0.1s, top 0.20s 0.1s, left 0.20s 0.1s;\n        transition: border 0.25s, background-color 0.25s, width 0.20s 0.1s, height 0.20s 0.1s, top 0.20s 0.1s, left 0.20s 0.1s;\n        z-index: 1; }\n      .react-selectrix.rs-base-checkboxes .rs-option input[type="checkbox"] + label:after {\n        height: 13px;\n        width: 13px;\n        background-color: transparent;\n        border: 2px solid #5a5a5a;\n        top: 0;\n        z-index: 0; }\n    .react-selectrix.rs-base-checkboxes .rs-option input[type="checkbox"]:checked + label:before {\n      top: 1px;\n      left: 0px;\n      width: 6px;\n      height: 10px;\n      border-top: 2px solid transparent;\n      border-left: 2px solid transparent;\n      border-right: 2px solid #fff;\n      border-bottom: 2px solid #fff;\n      -webkit-transform: rotateZ(37deg);\n      transform: rotateZ(37deg);\n      -webkit-transform-origin: 100% 100%;\n      transform-origin: 100% 100%; }\n    .react-selectrix.rs-base-checkboxes .rs-option input[type="checkbox"]:checked + label:after {\n      top: 0;\n      height: 13px;\n      width: 13px;\n      border: 1px solid #1DA4CF;\n      background-color: #1DA4CF;\n      z-index: 0;\n      border-radius: 2px; }\n    .react-selectrix.rs-base-checkboxes .rs-option input[type="checkbox"]:disabled + label {\n      opacity: 0.4;\n      cursor: not-allowed; }\n  .react-selectrix.rs-base-open.rs-base-materialize .rs-header:after {\n    content: "";\n    height: 2px;\n    background-color: #4379db;\n    display: block;\n    width: 100%;\n    left: 0;\n    visibility: visible; }\n  .react-selectrix.rs-base-open.rs-base-materialize .rs-arrow-indicator {\n    border-color: #4379db transparent transparent; }\n  .react-selectrix.rs-base-open.rs-base-materialize .rs-body {\n    opacity: 1;\n    -webkit-transform: scale(1) translateY(0);\n    -ms-transform: scale(1) translateY(0);\n    transform: scale(1) translateY(0);\n    visibility: visible;\n    height: auto; }\n  .react-selectrix .rs-arrow-indicator {\n    transition: 0.2s transform ease-in-out; }\n  .react-selectrix.rs-base-materialize.rs-base-multiple:not(.rs-base-empty) .rs-toggle {\n    padding-left: 0; }\n  .react-selectrix.rs-base-materialize .rs-header {\n    border: none;\n    border-bottom: 1px solid #eee;\n    border-radius: 0; }\n    .react-selectrix.rs-base-materialize .rs-header:after {\n      content: "";\n      height: 1px;\n      background-color: transparent;\n      position: absolute;\n      bottom: -1px;\n      display: block;\n      width: 15px;\n      left: 45%;\n      transition-duration: .2s;\n      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n      visibility: hidden; }\n  .react-selectrix.rs-base-materialize .rs-body {\n    display: block;\n    opacity: 0;\n    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n    transform-origin: 50% 0;\n    transform: scale(0.8) translateY(-15px);\n    transition: all 0.2s cubic-bezier(0.5, 0, 0, 1.25), opacity 0.15s ease-in-out;\n    visibility: hidden;\n    height: 0; }\n  .react-selectrix.rs-base-materialize .rs-toggle {\n    padding-left: 0; }\n    .react-selectrix.rs-base-materialize .rs-toggle.rs-focused {\n      box-shadow: none; }\n  .react-selectrix .rs-loader {\n    font-size: 10px;\n    margin: 15px auto;\n    overflow: hidden;\n    text-indent: -9999em;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: #00B2EE;\n    background: -moz-linear-gradient(left, #00B2EE 10%, rgba(255, 255, 255, 0) 42%);\n    background: -webkit-linear-gradient(left, #00B2EE 10%, rgba(255, 255, 255, 0) 42%);\n    background: -o-linear-gradient(left, #00B2EE 10%, rgba(255, 255, 255, 0) 42%);\n    background: -ms-linear-gradient(left, #00B2EE 10%, rgba(255, 255, 255, 0) 42%);\n    background: linear-gradient(to right, #00B2EE 10%, rgba(255, 255, 255, 0) 42%);\n    position: relative;\n    -webkit-animation: load3 1.4s infinite linear;\n    animation: load3 1.4s infinite linear;\n    -webkit-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    transform: translateZ(0); }\n  .react-selectrix.rs-base-materialize .rs-loader {\n    background: #4379db;\n    background: -moz-linear-gradient(left, #4379db 10%, rgba(255, 255, 255, 0) 42%);\n    background: -webkit-linear-gradient(left, #4379db 10%, rgba(255, 255, 255, 0) 42%);\n    background: -o-linear-gradient(left, #4379db 10%, rgba(255, 255, 255, 0) 42%);\n    background: -ms-linear-gradient(left, #4379db 10%, rgba(255, 255, 255, 0) 42%);\n    background: linear-gradient(to right, #4379db 10%, rgba(255, 255, 255, 0) 42%); }\n    .react-selectrix.rs-base-materialize .rs-loader:before {\n      background: #4379db; }\n  .react-selectrix .rs-loader:before {\n    width: 50%;\n    height: 50%;\n    background: #00B2EE;\n    border-radius: 100% 0 0 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: \'\'; }\n  .react-selectrix .rs-loader:after {\n    background: white;\n    width: 75%;\n    height: 75%;\n    border-radius: 50%;\n    content: \'\';\n    margin: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0; }\n\n@-webkit-keyframes load3 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n\n@keyframes load3 {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg); } }\n', ""]);
  }, function (e, t, r) {
    var n = r(12);
    "string" == typeof n && (n = [[e.i, n, ""]]);
    r(10)(n, {
      hmr: !0,
      transform: void 0
    }), n.locals && (e.exports = n.locals);
  }, function (e, t) {
    e.exports = function (e) {
      if (!e.webpackPolyfill) {
        var t = Object.create(e);
        t.children || (t.children = []), Object.defineProperty(t, "loaded", {
          enumerable: !0,
          get: function get() {
            return t.l;
          }
        }), Object.defineProperty(t, "id", {
          enumerable: !0,
          get: function get() {
            return t.i;
          }
        }), Object.defineProperty(t, "exports", {
          enumerable: !0
        }), t.webpackPolyfill = 1;
      }
      return t;
    };
  }, function (e, t, r) {
    "use strict";

    (function (e) {
      var r = "object" == typeof e && e && e.Object === Object && e;
      t.a = r;
    }).call(this, r(4));
  }]);
});